import React, { useEffect, useState } from "react"; 
import { useNavigate } from "react-router-dom";
import Header from '../../headerone/Main'
import { Link } from 'react-router-dom' 
import { Container, Grid, Typography, Button, Stack, Box, colors } from '@mui/material';
import NewMain from '../../headerone/newMain' 
import MainTitle from "../../muiHome/mainTitle";
import HomegalleryCompo from "../../muiHome/HomegalleryCompo"; 
 

function Convocation10th() {
 /* const navigate=useNavigate()
    useEffect(() => { 
        const pdfUrl = `${process.env.PUBLIC_URL}/assets/img/new_images/examination_scheme.pdf`;
         
        window.open(pdfUrl, '_blank');
        navigate(-1)
      }, []);  */

      const sheets = {
  "SBMC Deptt. Degree ": {
    "headers": [
      "SR.\nNo",
      "University Roll Number",
      "REGN. NO.",
      "STUDENT'S NAME",
      "छात्र का नाम",
      "FATHER'S NAME",
      "पिता का नाम",
      "MOTHER'S NAME",
      "Course\n Name ",
      "Stream",
      "CGPA_Print",
      "Division",
      "Session"
    ],
    "rows": [
      [
        "1",
        "22091001",
        "22CM1001",
        "ANJALI",
        "अंजलि",
        "ZILE SINGH",
        "ज़िले सिंह",
        "SAVITA",
        "Bachelor of Commerce",
        " (Honours)",
        "9.48",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "2",
        "22091002",
        "22CM1002",
        "BHUMI",
        "भूमि",
        "SUBHASH",
        "सुभाष",
        "REKHA",
        "Bachelor of Commerce",
        " (Honours)",
        "8.95",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "3",
        "22091003",
        "22CM1003",
        "DALIP",
        "दलीप",
        "RAJVIR",
        "राजवीर",
        "RAMBHUTARI",
        "Bachelor of Commerce",
        " (Honours)",
        "7.32",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "4",
        "22091004",
        "22CM1004",
        "HIMANI NARULA",
        "हिमानी नरूला",
        "SANJAY NARULA",
        "संजय नरूला",
        "MANJU NARULA",
        "Bachelor of Commerce",
        " (Honours)",
        "8.96",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "5",
        "22091005",
        "22CM1005",
        "JAISIKA",
        "जैसिका",
        "VISHNU SINGLA",
        "विष्णु सिंगला",
        "SEEMA",
        "Bachelor of Commerce",
        " (Honours)",
        "8.91",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "6",
        "22091006",
        "22CM1006",
        "SAPNA",
        "सपना",
        "HEMRAJ",
        "हेमराज",
        "POOJA",
        "Bachelor of Commerce",
        " (Honours)",
        "6.93",
        "First Division",
        "MAY-2025"
      ],
      [
        "7",
        "22091007",
        "22CM1007",
        "SHIVA CHAUHAN",
        "शिवा चौहान",
        "LEKHRAJ",
        "लेखराज",
        "SUNITA",
        "Bachelor of Commerce",
        " (Honours)",
        "4.81",
        "Second Division",
        "SEPTEMBER-2025"
      ],
      [
        "8",
        "22091008",
        "22CM1008",
        "KALYAN JI JHA",
        "कल्याण जी झा",
        "SUSHIL JHA",
        "सुशील झा",
        "ANSHU JHA",
        "Bachelor of Commerce",
        " (Honours)",
        "8.35",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "9",
        "21091005",
        "21CM1005",
        "GULSHAN SOROUT",
        "गुलशन सोरौत",
        "SUNDER SINGH",
        "सुंदर सिंह",
        "JAYA KUMARI",
        "Bachelor of Commerce",
        " (Honours)",
        "5.41",
        "Second Division",
        "MAY-2024"
      ],
      [
        "10",
        "22041001",
        "22MS1001",
        "AARTI SOROUT",
        "आरती सोरौत",
        "PADAM SINGH",
        "पदम सिंह",
        "BEENA",
        "Bachelor of Business Administration",
        "",
        "8.47",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "11",
        "22041003",
        "22MS1003",
        "DIMPLE",
        "डिंपल",
        "AJAY SAINI",
        "अजय सैनी",
        "MAMTA SAINI",
        "Bachelor of Business Administration",
        "",
        "8.61",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "12",
        "22041004",
        "22MS1004",
        "HARDIK BINDAL",
        "हार्दिक बिंदल",
        "DINESH BINDAL",
        "दिनेश बिंदल",
        "VARSHA BINDAL",
        "Bachelor of Business Administration",
        "",
        "5.35",
        "Second Division",
        "MAY-2025"
      ],
      [
        "13",
        "22041005",
        "22MS1005",
        "HARSHIT",
        "हर्षित",
        "JOGENDER",
        "जोगेंद्र",
        "POONAM SOROUT",
        "Bachelor of Business Administration",
        "",
        "6.21",
        "First Division",
        "SEPTEMBER-2025"
      ],
      [
        "14",
        "22041006",
        "22MS1006",
        "HARSHIT VERMA",
        "हर्षित वर्मा",
        "SH NEERAJ VERMA",
        "श्री नीरज वर्मा",
        "SMT SEEMA VERMA",
        "Bachelor of Business Administration",
        "",
        "5.39",
        "Second Division",
        "SEPTEMBER-2025"
      ],
      [
        "15",
        "22041009",
        "22MS1009",
        "IMLAKH",
        "इमलख",
        "HARUN",
        "हारुन",
        "SAHIRA",
        "Bachelor of Business Administration",
        "",
        "6.10",
        "First Division",
        "MAY-2025"
      ],
      [
        "16",
        "22041010",
        "22MS1010",
        "JYOTI",
        "ज्योति",
        "RAM CHAND",
        "राम चंद",
        "KIRAN TANWAR",
        "Bachelor of Business Administration",
        "",
        "7.93",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "17",
        "22041012",
        "22MS1012",
        "MANISHA",
        "मनीषा",
        "GYANENDER",
        "ज्ञानेंद्र",
        "KAMLESH",
        "Bachelor of Business Administration",
        "",
        "6.65",
        "First Division",
        "MAY-2025"
      ],
      [
        "18",
        "22041014",
        "22MS1014",
        "SHIVANGI",
        "शिवांगी",
        "RAMAVTAR SHARMA",
        "रामअवतार शर्मा",
        "SANDHYA",
        "Bachelor of Business Administration",
        "",
        "6.70",
        "First Division",
        "SEPTEMBER-2025"
      ],
      [
        "19",
        "22041015",
        "22MS1015",
        "YASHIKA MANGLA",
        "यशिका मंगला",
        "BHISHAM MANGLA",
        "भीष्म मंगला",
        "SAPNA MANGLA",
        "Bachelor of Business Administration",
        "",
        "8.08",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "20",
        "22041016",
        "22MS1016",
        "MOHIT",
        "मोहित",
        "SHANTVIR",
        "शांतवीर",
        "REKHA",
        "Bachelor of Business Administration",
        "",
        "5.34",
        "Second Division",
        "MAY-2025"
      ],
      [
        "21",
        "22041017",
        "22MS1017",
        "SANGEETA",
        "संगीता",
        "SURENDER",
        "सुरेंद्र",
        "ASHA",
        "Bachelor of Business Administration",
        "",
        "8.36",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "22",
        "22041018",
        "22MS1018",
        "SUMIT",
        "सुमित",
        "SURENDER SINGH",
        "सुरेंद्र सिंह",
        "ANITA",
        "Bachelor of Business Administration",
        "",
        "6.02",
        "First Division",
        "SEPTEMBER-2025"
      ],
      [
        "23",
        "22041020",
        "22MS1020",
        "HITESH MALIYA",
        "हितेश मालिया",
        "VEDPAL",
        "वेदपाल",
        "SAVITA",
        "Bachelor of Business Administration",
        "",
        "6.36",
        "First Division",
        "SEPTEMBER-2025"
      ],
      [
        "24",
        "22041021",
        "22MS1021",
        "BHAWNA SHARMA",
        "भावना शर्मा",
        "GANGA RAM SHARMA",
        "गंगा राम शर्मा",
        "PINKY SHARMA",
        "Bachelor of Business Administration",
        "",
        "7.24",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "25",
        "22041022",
        "22MS1022",
        "KAPIL RAWAT ",
        "कपिल रावत",
        "DINESH KUMAR",
        "दिनेश कुमार",
        "ANITA",
        "Bachelor of Business Administration",
        "",
        "7.53",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "26",
        "22041023",
        "22MS1023",
        "SAURABH KUMAR BANSHIWAL",
        "सौरभ कुमार बंशीवाल",
        "JAGDISH",
        "जगदीश",
        "TIRATH BAI",
        "Bachelor of Business Administration",
        "",
        "8.26",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "27",
        "23051003",
        "23MS5003",
        "GOURAV",
        "गौरव",
        "RAMNIWAS",
        "रामनिवास",
        "REKHA",
        "Master of Business Administration",
        "(Human Resource Management & Marketing Management)",
        "5.55",
        "Second Division",
        "SEPTEMBER-2025"
      ],
      [
        "28",
        "23051006",
        "23MS5006",
        "KRISHAN KAUSHIK",
        "कृष्ण कौशिक",
        "CHANDERPAL KAUSHIK",
        "चंद्रपाल कौशिक",
        "KAMLESH",
        "Master of Business Administration",
        "(Human Resource Management & Marketing Management)",
        "7.00",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "29",
        "23051007",
        "23MS5007",
        "KRITI AGGARWAL",
        "कृति अग्रवाल",
        "KRISHAN KUMAR",
        "कृष्ण कुमार",
        "YOGITA",
        "Master of Business Administration",
        "(Human Resource Management & Marketing Management)",
        "8.00",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "30",
        "23051010",
        "23MS5010",
        "RAHUL SINGH",
        "राहुल सिंह",
        "RAJBIR SINGH",
        "राजबीर सिंह",
        "KAVITA",
        "Master of Business Administration",
        "(Human Resource Management & Marketing Management)",
        "7.08",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "31",
        "23051001",
        "23MS5001",
        "CHINTOO",
        "चिंटू",
        "VEER SINGH",
        "वीर सिंह",
        "OMBATI DEVI",
        "Master of Business Administration",
        "(Human Resource Management & Financial Management)",
        "7.62",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "32",
        "23051002",
        "23MS5002",
        "DIVYA",
        "दिव्या",
        "RAJ SINGH",
        "राज सिंह",
        "SUSHILA",
        "Master of Business Administration",
        "(Human Resource Management & Financial Management)",
        "7.90",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "33",
        "23051005",
        "23MS5005",
        "KOMAL SOROUT",
        "कोमल सोरौत",
        "NAROTTAM SOROUT",
        "नरोत्तम सोरौत",
        "SUNITA KUMARI",
        "Master of Business Administration",
        "(Human Resource Management & Financial Management)",
        "6.18",
        "First Division",
        "SEPTEMBER-2025"
      ],
      [
        "34",
        "23051008",
        "23MS5008",
        "MEGHA",
        "मेघा",
        "DHARAMVIR",
        "धर्मवीर",
        "JYOTI",
        "Master of Business Administration",
        "(Human Resource Management & Financial Management)",
        "9.28",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "35",
        "23051011",
        "23MS5011",
        "RASHID",
        "रशीद",
        "ILIYAS",
        "इलियास",
        "SAMEENA",
        "Master of Business Administration",
        "(Human Resource Management & Financial Management)",
        "5.76",
        "Second Division",
        "SEPTEMBER-2025"
      ],
      [
        "36",
        "23051012",
        "23MS5012",
        "RITU BHARDWAJ",
        "ऋतु भारद्वाज",
        "SUDHIR KRISHAN",
        "सुधीर कृष्ण",
        "MADHU BALA",
        "Master of Business Administration",
        "(Human Resource Management & Financial Management)",
        "8.51",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "37",
        "23051013",
        "23MS5013",
        "SHIVANI",
        "शिवानी",
        "RAJENDER KUMAR",
        "राजेंद्र कुमार",
        "NIRAN WATI",
        "Master of Business Administration",
        "(Human Resource Management & Financial Management)",
        "8.59",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "38",
        "23051018",
        "23MS5018",
        "VIKAR KHAN",
        "विकार खान",
        "SHAMSUDDIN",
        "शमसुद्दीन",
        "SAMEENA",
        "Master of Business Administration",
        "(Human Resource Management & Financial Management)",
        "6.29",
        "First Division",
        "MAY-2025"
      ],
      [
        "39",
        "23051019",
        "23MS5019",
        "PRIYA",
        "प्रिया",
        "RAJESH SHARMA",
        "राजेश शर्मा",
        "SUNITA",
        "Master of Business Administration",
        "(Human Resource Management & Financial Management)",
        "7.69",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "40",
        "23051020",
        "23MS5020",
        "PRIYA RANI",
        "प्रिया रानी",
        "BRIJ KISHOR",
        "बृज किशोर",
        "REKHA RANI",
        "Master of Business Administration",
        "(Human Resource Management & Financial Management)",
        "7.74",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "41",
        "23051021",
        "23MS5021",
        "YOGESH",
        "योगेश",
        "YASH PAL",
        "यश पाल",
        "KUSUM",
        "Master of Business Administration",
        "(Human Resource Management & Financial Management)",
        "6.09",
        "First Division",
        "MAY-2025"
      ],
      [
        "42",
        "23051024",
        "23MS5024",
        "RAHUL SOLANKI",
        "राहुल सोलंकी",
        "JAI VEER SOLANKI",
        "जय वीर सोलंकी",
        "KABITA DEVI",
        "Master of Business Administration",
        "(Human Resource Management & Financial Management)",
        "5.99",
        "Second Division",
        "MAY-2025"
      ],
      [
        "43",
        "23051025",
        "23MS5025",
        "ATUL",
        "अतुल",
        "BUDH RAM",
        "बुध राम",
        "SUNITA",
        "Master of Business Administration",
        "(Human Resource Management & Financial Management)",
        "5.91",
        "Second Division",
        "MAY-2025"
      ],
      [
        "44",
        "23051014",
        "23MS5014",
        "TIPANSU VATS",
        "तिपांसु वत्स",
        "VIJAY KUMAR",
        "विजय कुमार",
        "ARUNA",
        "Master of Business Administration",
        "(Marketing Management  & Business Analytics)",
        "6.55",
        "First Division",
        "SEPTEMBER-2025"
      ],
      [
        "45",
        "23051009",
        "23MS5009",
        "NEHA SHARMA",
        "नेहा शर्मा",
        "GIRIRAJ SHARMA",
        "गिरिराज शर्मा",
        "SUSHILA DEVI",
        "Master of Business Administration",
        "Financial Management & Business Analytics",
        "8.81",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "46",
        "23051015",
        "23MS5015",
        "KIRTI",
        "कीर्ति",
        "NARENDERPAL SINGH",
        "नरेंद्रपाल सिंह",
        "HARMUKHI",
        "Master of Business Administration",
        "Financial Management & Business Analytics",
        "7.20",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "47",
        "23051016",
        "23MS5016",
        "RAHUL",
        "राहुल",
        "YASHVEER",
        "यशवीर",
        "GYANWATI",
        "Master of Business Administration",
        "Financial Management & Business Analytics",
        "5.36",
        "Second Division",
        "SEPTEMBER-2025"
      ],
      [
        "48",
        "23051017",
        "23MS5017",
        "SHIVAM",
        "शिवम",
        "RAMPRASAD",
        "रामप्रसाद",
        "SUNITA",
        "Master of Business Administration",
        "Financial Management & Business Analytics",
        "5.46",
        "Second Division",
        "SEPTEMBER-2025"
      ]
    ]
  },
  "LAW": {
    "headers": [
      "SR.\nNo",
      "University Roll Number",
      "CLASS ROLL No /REGN. NO.",
      "STUDENT'S NAME",
      "छात्र का नाम",
      "FATHER'S NAME",
      "पिता का नाम",
      "MOTHER'S NAME",
      "Course\n Name ",
      "",
      "CGPA",
      "Division",
      "Session"
    ],
    "rows": [
      [
        "36",
        "22132003",
        "22SL4003",
        "DEEPAK",
        "दीपक",
        "CHARAN SINGH",
        "चरण सिंह",
        "RANBIRI",
        "Bachelor of Laws",
        "",
        "6.97",
        "First Division",
        "MAY-2025"
      ],
      [
        "2",
        "20134003",
        "20SL2003",
        "BHANU PRAKASH",
        "भानु प्रकाश",
        "CHATTER SINGH",
        "चटर सिंह",
        "JYOTI",
        "BALL.B.",
        "(5 Years Integrated Program)",
        "5.84",
        "Second Division",
        "SEPTEMBER-2025"
      ],
      [
        "21",
        "20134030",
        "20SL2030",
        "SOHIL",
        "सोहिल",
        "LIYAKAT",
        "लियाकत",
        "ARSHIDA",
        "BALL.B.",
        "(5 Years Integrated Program)",
        "6.95",
        "First Division",
        "MAY-2025"
      ],
      [
        "37",
        "22132005",
        "22SL4005",
        "KOMAL",
        "कोमल",
        "SHRADHA NAND",
        "श्रद्धा नंद",
        "SHARMILA",
        "Bachelor of Laws",
        "",
        "6.92",
        "First Division",
        "MAY-2025"
      ],
      [
        "5",
        "20134007",
        "20SL2007",
        "JAIRNAIL SINGH",
        "जरनैल सिंह",
        "NIRANJAN SINGH",
        "निरंजन सिंह",
        "CHANDAN KAUR",
        "BALL.B.",
        "(5 Years Integrated Program)",
        "7.06",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "60",
        "24133007",
        "24SL7007",
        "ATISHAY JAIN",
        "अतिशय जैन",
        "AMIT KR JAIN",
        "अमित केआर जैन",
        "NIDHI JAIN",
        "Master of Laws",
        "(Corporate and Commercial Law)",
        "6.92",
        "First Division",
        "MAY-2025"
      ],
      [
        "32",
        "20131010",
        "20SL1010",
        "TAKSH GARG",
        "तक्ष गर्ग",
        "MANOJ KUMAR",
        "मनोज कुमार",
        "MAMTA RANI",
        "BBALL.B.",
        "(5 Years Integrated Program)",
        "6.91",
        "First Division",
        "MAY-2025"
      ],
      [
        "8",
        "20134010",
        "20SL2010",
        "MAMTA TEWATIA",
        "ममता तेवतिया",
        "DINESH SINGH",
        "दिनेश सिंह",
        "DEVENDRI TEWATIA",
        "BALL.B.",
        "(5 Years Integrated Program)",
        "7.05",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "9",
        "20134011",
        "20SL2011",
        "MUSKAN SHARMA",
        "मुस्कान शर्मा",
        "BHUP SINGH",
        "भूप सिंह",
        "MINAKSHI",
        "BALL.B.",
        "(5 Years Integrated Program)",
        "8.67",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "10",
        "20134013",
        "20SL2013",
        "SAHID",
        "शाहिद",
        "AASAM",
        "आसम",
        "FIRDOS",
        "BALL.B.",
        "(5 Years Integrated Program)",
        "7.04",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "11",
        "20134014",
        "20SL2014",
        "SANGEETA CHAUHAN",
        "संगीता चौहान",
        "DHARAMVEER CHAUHAN",
        "धर्मवीर चौहान",
        "VIMLESH CHAUHAN",
        "BALL.B.",
        "(5 Years Integrated Program)",
        "7.90",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "31",
        "20131009",
        "20SL1009",
        "PARTHA CHAKRABORTY",
        "पार्थ चक्रवर्ती",
        "MANIK CHAKRABORTY",
        "मानिक चक्रवर्ती",
        "BARNALI CHAKRABORTY",
        "BBALL.B.",
        "(5 Years Integrated Program)",
        "6.83",
        "First Division",
        "MAY-2025"
      ],
      [
        "13",
        "20134017",
        "20SL2017",
        "VAISHNAVI",
        "वैष्णवी",
        "VISHNU DUTT",
        "विष्णु दत्त",
        "NEERU KAUSHIK",
        "BALL.B.",
        "(5 Years Integrated Program)",
        "6.75",
        "First Division",
        "MAY-2025"
      ],
      [
        "28",
        "20131006",
        "20SL1006",
        "SIDHARTH KUMAR GORIA",
        "सिद्धार्थ कुमार गोरिया",
        "ROHTASH KUMAR",
        "रोहताश कुमार",
        "GEETA DEVI",
        "BBALL.B.",
        "(5 Years Integrated Program)",
        "6.75",
        "First Division",
        "MAY-2025"
      ],
      [
        "15",
        "20134020",
        "20SL2020",
        "RISHAB JAIN",
        "ऋषभ जैन",
        "DAYA CHAND JAIN",
        "दया चंद जैन",
        "SHASHI JAIN",
        "BALL.B.",
        "(5 Years Integrated Program)",
        "7.88",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "25",
        "20131002",
        "20SL1002",
        "MOHIT KUMAR",
        "मोहित कुमार",
        "RAJENDER KUMAR",
        "राजेंद्र कुमार",
        "ANITA",
        "BBALL.B.",
        "(5 Years Integrated Program)",
        "6.74",
        "First Division",
        "MAY-2025"
      ],
      [
        "1",
        "20134001",
        "20SL2001",
        "AFRAIL",
        "अफ़्राइल",
        "AKHTAR ALI",
        "अख्तर अली",
        "GHURA",
        "BALL.B.",
        "(5 Years Integrated Program)",
        "6.73",
        "First Division",
        "MAY-2025"
      ],
      [
        "18",
        "20134024",
        "20SL2024",
        "ANJU DEVI",
        "अंजू देवी",
        "SATVIR",
        "सतवीर",
        "GEETA DEVI",
        "BALL.B.",
        "(5 Years Integrated Program)",
        "8.27",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "19",
        "20134028",
        "20SL2028",
        "DEEPAK BAISLA",
        "दीपक बैसला",
        "SATPAL SINGH",
        "सतपाल सिंह",
        "KAMLESH",
        "BALL.B.",
        "(5 Years Integrated Program)",
        "7.38",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "41",
        "22132010",
        "22SL4010",
        "RUKAINYA",
        "रुकैन्या",
        "TAHIR HUSSAIIN",
        "ताहिर हुसैन",
        "BASKARI",
        "Bachelor of Laws",
        "",
        "6.73",
        "First Division",
        "MAY-2025"
      ],
      [
        "14",
        "20134018",
        "20SL2018",
        "VIKASH",
        "विकास",
        "RANVEER SINGH",
        "रणवीर सिंह",
        "OMWATI",
        "BALL.B.",
        "(5 Years Integrated Program)",
        "6.70",
        "First Division",
        "MAY-2025"
      ],
      [
        "33",
        "20131011",
        "20SL1011",
        "MOHD DILSHAD",
        "मोहम्मद दिलशाद",
        "AZAD KHAN",
        "आजाद खान",
        "SAGGO",
        "BBALL.B.",
        "(5 Years Integrated Program)",
        "6.70",
        "First Division",
        "MAY-2025"
      ],
      [
        "20",
        "20134029",
        "20SL2029",
        "BILAL",
        "बिलाल",
        "IKBAL",
        "इकबाल",
        "RUKSEENA",
        "BALL.B.",
        "(5 Years Integrated Program)",
        "6.68",
        "First Division",
        "MAY-2025"
      ],
      [
        "24",
        "20131001",
        "20SL1001",
        "DHRUV DAGAR",
        "ध्रुव डागर",
        "RAM KUMAR DAGAR",
        "राम कुमार डागर",
        "AMITA",
        "BBALL.B.",
        "(5 Years Integrated Program)",
        "7.04",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "61",
        "24133008",
        "24SL7008",
        "SHILPA THAKRAN",
        "शिल्पा ठाकरान",
        "S S THAKRAN",
        "एस एस ठाकरन",
        "SAROJ THAKRAN",
        "Master of Laws",
        "(Corporate and Commercial Law)",
        "6.68",
        "First Division",
        "MAY-2025"
      ],
      [
        "26",
        "20131003",
        "20SL1003",
        "NAMITA CHOUDHARY",
        "नमिता चौधरी",
        "KISHORI LAL",
        "किशोरी लाल",
        "MEERA DEVI",
        "BBALL.B.",
        "(5 Years Integrated Program)",
        "7.09",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "27",
        "20131005",
        "20SL1005",
        "NISHA RAWAT",
        "निशा रावत",
        "AJAY KUMAR RAWAT",
        "अजय कुमार रावत",
        "ANITA RAWAT",
        "BBALL.B.",
        "(5 Years Integrated Program)",
        "8.25",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "16",
        "20134022",
        "20SL2022",
        "RAJIV SINGH",
        "राजीव सिंह",
        "HARI SINGH",
        "हरि सिंह",
        "BHUTERI DEVI",
        "BALL.B.",
        "(5 Years Integrated Program)",
        "6.63",
        "First Division",
        "MAY-2025"
      ],
      [
        "29",
        "20131007",
        "20SL1007",
        "SIMRAN",
        "सिमरन",
        "SUNDER SINGH",
        "सुंदर सिंह",
        "SUNITA",
        "BBALL.B.",
        "(5 Years Integrated Program)",
        "7.82",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "30",
        "20131008",
        "20SL1008",
        "TABITHA MARIE BUHION NAIDU",
        "तबिथा मेरी बुहियन नायडू",
        "SAMPATH KR MENDU MUNISWAMY NAIDU",
        "संपत कुमार मेंडू मुनिस्वामी नायडू",
        "MARIA CORAZON BUHION NAIDU",
        "BBALL.B.",
        "(5 Years Integrated Program)",
        "7.21",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "7",
        "20134009",
        "20SL2009",
        "LAKSHAY GUPTA",
        "लक्ष्य गुप्ता",
        "SUBHASH CHAND",
        "सुभाष चंद",
        "MANJU GUPTA",
        "BALL.B.",
        "(5 Years Integrated Program)",
        "6.54",
        "First Division",
        "MAY-2025"
      ],
      [
        "4",
        "20134006",
        "20SL2006",
        "GAJENDER TANWAR",
        "गजेंद्र तंवर",
        "SOHAN LAL TANWAR",
        "सोहन लाल तंवर",
        "SANTRA",
        "BALL.B.",
        "(5 Years Integrated Program)",
        "6.51",
        "First Division",
        "MAY-2025"
      ],
      [
        "53",
        "22132022",
        "22SL4022",
        "VAIBHAV CHAUHAN",
        "वैभव चौहान",
        "KRISHAN KUMAR",
        "कृष्ण कुमार",
        "SUNITA",
        "Bachelor of Laws",
        "",
        "6.49",
        "First Division",
        "MAY-2025"
      ],
      [
        "34",
        "22132001",
        "22SL4001",
        "AABIL HUSSAIN",
        "आबिल हुसैन",
        "FAKHRUDDIN",
        "फखरुद्दीन",
        "AKHTARI",
        "Bachelor of Laws",
        "",
        "7.23",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "17",
        "20134023",
        "20SL2023",
        "ROHIT",
        "रोहित",
        "SOM DEV",
        "सोम देव",
        "PREMLATA",
        "BALL.B.",
        "(5 Years Integrated Program)",
        "6.38",
        "First Division",
        "MAY-2025"
      ],
      [
        "43",
        "22132012",
        "22SL4012",
        "SAURAV TANWAR",
        "सौरव तंवर",
        "MAHESH CHAND",
        "महेश चंद",
        "KAMLA",
        "Bachelor of Laws",
        "",
        "6.23",
        "First Division",
        "MAY-2025"
      ],
      [
        "22",
        "20134031",
        "20SL2031",
        "ROHIT",
        "रोहित",
        "DHARMBIR SINGH",
        "धर्मबीर सिंह",
        "OMBATI",
        "BALL.B.",
        "(5 Years Integrated Program)",
        "6.21",
        "First Division",
        "MAY-2025"
      ],
      [
        "38",
        "22132006",
        "22SL4006",
        "KOMAL KAUSHIK",
        "कोमल कौशिक",
        "PRITAM KAUSHIK",
        "प्रीतम कौशिक",
        "SUNITA KAUSHIK",
        "Bachelor of Laws",
        "",
        "7.55",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "39",
        "22132008",
        "22SL4008",
        "MANISH BANSAL",
        "मनीष बंसल",
        "LALA RAM BANSAL",
        "लाला राम बंसल",
        "SUNITA BANSAL",
        "Bachelor of Laws",
        "",
        "5.72",
        "Second Division",
        "MAY-2025"
      ],
      [
        "40",
        "22132009",
        "22SL4009",
        "MANJEET",
        "मनजीत",
        "SURESH ",
        "सुरेश",
        "SHASHI",
        "Bachelor of Laws",
        "",
        "5.62",
        "Second Division",
        "MAY-2025"
      ],
      [
        "35",
        "22132002",
        "22SL4002",
        "BALWAN CHAUHAN",
        "बलवान चौहान",
        "VIKRAM SINGH",
        "विक्रम सिंह",
        "SUSHILA DEVI",
        "Bachelor of Laws",
        "",
        "6.19",
        "First Division",
        "MAY-2025"
      ],
      [
        "42",
        "22132011",
        "22SL4011",
        "SAHID",
        "शाहिद",
        "YUNUS",
        "यूनुस",
        "RABEENA",
        "Bachelor of Laws",
        "",
        "5.58",
        "Second Division",
        "MAY-2025"
      ],
      [
        "64",
        "24133004",
        "24SL7004",
        "VISHAL",
        "विशाल",
        "BHARAT BHOOSHAN",
        "भारत भूषण",
        "SAROJ",
        "Master of Laws",
        "(Criminal Law)",
        "6.16",
        "First Division",
        "MAY-2025"
      ],
      [
        "44",
        "22132013",
        "22SL4013",
        "SHILPA SHARMA",
        "शिल्पा शर्मा",
        "PRITAM CHAND",
        "प्रीतम चंद",
        "TRISHLA DEVI",
        "Bachelor of Laws",
        "",
        "7.30",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "45",
        "22132014",
        "22SL4014",
        "SHIVA DAGAR",
        "शिवा डागर",
        "OMBIR DAGAR",
        "ओमबीर डागर",
        "LACCHO DAGAR",
        "Bachelor of Laws",
        "",
        "5.75",
        "Second Division",
        "MAY-2025"
      ],
      [
        "46",
        "22132015",
        "22SL4015",
        "TAREEF",
        "तारीफ",
        "JAIKAM KHAN",
        "जैकम खान",
        "KHURSHIDAN",
        "Bachelor of Laws",
        "",
        "5.91",
        "Second Division",
        "MAY-2025"
      ],
      [
        "47",
        "22132016",
        "22SL4016",
        "SUKHWINDER",
        "सुखविंदर",
        "BRAHMJEET",
        "ब्रह्मजीत",
        "RAJBATI",
        "Bachelor of Laws",
        "",
        "8.20",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "48",
        "22132017",
        "22SL4017",
        "TANU RAJ",
        "तनु राज",
        "VED RAM",
        "वेद राम",
        "ASHA KUMARI",
        "Bachelor of Laws",
        "",
        "8.22",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "49",
        "22132018",
        "22SL4018",
        "YOGESH",
        "योगेश",
        "SHRINIWAS",
        "श्रीनिवास",
        "REKHA",
        "Bachelor of Laws",
        "",
        "5.60",
        "Second Division",
        "MAY-2025"
      ],
      [
        "50",
        "22132019",
        "22SL4019",
        "RUCHI",
        "रुचि",
        "OMBIR SINGH",
        "ओमबीर सिंह",
        "VERSHA RANI",
        "Bachelor of Laws",
        "",
        "7.38",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "6",
        "20134008",
        "20SL2008",
        "JASVEER SOROUT",
        "जसवीर सोरौत",
        "SURESH",
        "सुरेश",
        "SAROJ",
        "BALL.B.",
        "(5 Years Integrated Program)",
        "6.15",
        "First Division",
        "MAY-2025"
      ],
      [
        "52",
        "22132021",
        "22SL4021",
        "JAHANVI GUPTA",
        "जाहन्वी गुप्ता",
        "HEMANT GUPTA",
        "हेमंत गुप्ता",
        "SHEETAL GUPTA",
        "Bachelor of Laws",
        "",
        "8.08",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "12",
        "20134016",
        "20SL2016",
        "TARUN ",
        "तरुण",
        "MAHIPAL SINGH",
        "महिपाल सिंह",
        "KAVITA",
        "BALL.B.",
        "(5 Years Integrated Program)",
        "6.14",
        "First Division",
        "MAY-2025"
      ],
      [
        "54",
        "22132023",
        "22SL4023",
        "LALIT KUMAR",
        "ललित कुमार",
        "BEDRAM",
        "बेदराम",
        "RAJLATA",
        "Bachelor of Laws",
        "",
        "5.29",
        "Second Division",
        "MAY-2025"
      ],
      [
        "55",
        "20132009",
        "20SL4009",
        "SHIV DUTT",
        "शिव दत्त",
        "NAND KISHORE",
        "नंद किशोर",
        "KUNTI",
        "Bachelor of Laws",
        "",
        "5.42",
        "Second Division",
        "MAY-2025"
      ],
      [
        "56",
        "24133009",
        "24SL7009",
        "SANDIP CHHABRA",
        "संदीप छाबड़ा",
        "GHANSHYAM DASS CHHABRA",
        "घनश्याम दास छाबड़ा",
        "PADAMA CHHABRA",
        "Master of Laws",
        "(Constitutional and Administrative Law)",
        "7.48",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "57",
        "24133010",
        "24SL7010",
        "CHANDRA SHEKHER RAI",
        "चंद्र शेखर राय",
        "N N RAI",
        "एन एन राय",
        "KAMLAWATI RAI",
        "Master of Laws",
        "(Constitutional and Administrative Law)",
        "7.16",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "58",
        "24133003",
        "24SL7003",
        "VIKAS KABEER",
        "विकास कबीर",
        "RAM KUMAR",
        "राम कुमार",
        "LATA",
        "Master of Laws",
        "(Corporate and Commercial Law)",
        "8.20",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "59",
        "24133006",
        "24SL7006",
        "HARSHITA YADAV",
        "हर्षिता यादव",
        "DEVENDER SINGH",
        "देवेंद्र सिंह",
        "MANJU YADAV",
        "Master of Laws",
        "(Corporate and Commercial Law)",
        "7.16",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "23",
        "20134032",
        "20SL2032",
        "HARSHIT TEWATIA",
        "हर्षित तेवतिया",
        "DEVENDER TEWATIA",
        "देवेंद्र तेवतिया",
        "ANITA TEWATIA",
        "BALL.B.",
        "(5 Years Integrated Program)",
        "6.12",
        "First Division",
        "MAY-2025"
      ],
      [
        "3",
        "20134005",
        "20SL2005",
        "DIVYANSHU",
        "दिव्यांशु",
        "KARAMBIR SINGH",
        "करमबीर सिंह",
        "KUSUM LATA",
        "BALL.B.",
        "(5 Years Integrated Program)",
        "6.07",
        "First Division",
        "SEPTEMBER-2025"
      ],
      [
        "62",
        "24133001",
        "24SL7001",
        "KRISHNA PURI",
        "कृष्णा पुरी",
        "DAYACHAND PURI",
        "दयाचंद पुरी",
        "KUSUM PURI",
        "Master of Laws",
        "(Criminal Law)",
        "7.46",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "63",
        "24133002",
        "24SL7002",
        "RITESH GUPTA",
        "रितेश गुप्ता",
        "ASHOK GUPTA",
        "अशोक गुप्ता",
        "SUNITA GUPTA",
        "Master of Laws",
        "(Criminal Law)",
        "7.94",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "51",
        "22132020",
        "22SL4020",
        "SAHIL",
        "साहिल",
        "SUNIL KUMAR",
        "सुनील कुमार",
        "DHARMWATI",
        "Bachelor of Laws",
        "",
        "6.04",
        "First Division",
        "MAY-2025"
      ],
      [
        "65",
        "24133005",
        "24SL7005",
        "DHIRAJ TEWATIA",
        "धीरज तेवतिया",
        "DEVENDER KUMAR TEWATIA",
        "देवेंद्र कुमार तेवतिया",
        "DAYA VATI",
        "Master of Laws",
        "(Criminal Law)",
        "7.30",
        "First Division With Distinction",
        "MAY-2025"
      ]
    ]
  },
  "PHARMACY": {
    "headers": [
      "SR.\nNo",
      "University Roll Number",
      "REGN. NO.",
      "STUDENT'S NAME",
      "छात्र का नाम",
      "FATHER'S NAME",
      "पिता का नाम",
      "MOTHER'S NAME",
      "Course\n Name ",
      "Stream",
      "CGPA_Print",
      "First Division",
      "Session",
      ""
    ],
    "rows": [
      [
        "1",
        "21121003",
        "21PS1003",
        "AMIT KUMAR",
        "अमित कुमार",
        "GOPAL",
        "गोपाल",
        "MEENU",
        "Bachelor of Pharmacy",
        "",
        "8.40",
        "First Division With Distinction",
        "MAY-2025",
        ""
      ],
      [
        "2",
        "21121004",
        "21PS1004",
        "ANUJ THAKUR",
        "अनुज ठाकुर",
        "SURESH KUMAR",
        "सुरेश कुमार",
        "BEENA ",
        "Bachelor of Pharmacy",
        "",
        "8.98",
        "First Division With Distinction",
        "MAY-2025",
        ""
      ],
      [
        "3",
        "21121006",
        "21PS1006",
        "ATUL SHARMA",
        "अतुल शर्मा",
        "TANVIR SHARMA",
        "तनवीर शर्मा",
        "PAWAN KUMARI",
        "Bachelor of Pharmacy",
        "",
        "7.14",
        "First Division",
        "MAY-2025",
        ""
      ],
      [
        "4",
        "21121007",
        "21PS1007",
        "BHAGAT SHARMA",
        "भगत शर्मा",
        "SUKHPAL",
        "सुखपाल",
        "OMBATI",
        "Bachelor of Pharmacy",
        "",
        "8.45",
        "First Division With Distinction",
        "MAY-2025",
        ""
      ],
      [
        "5",
        "21121008",
        "21PS1008",
        "BHAGAT SINGH",
        "भगत सिंह",
        "RAJVIR SINGH",
        "राजवीर सिंह",
        "MEMBATI",
        "Bachelor of Pharmacy",
        "",
        "8.05",
        "First Division With Distinction",
        "MAY-2025",
        ""
      ],
      [
        "6",
        "21121010",
        "21PS1010",
        "BHUPENDER",
        "भूपेंद्र",
        "ROHTASH",
        "रोहताश",
        "MANJU",
        "Bachelor of Pharmacy",
        "",
        "7.97",
        "First Division With Distinction",
        "MAY-2025",
        ""
      ],
      [
        "7",
        "21121011",
        "21PS1011",
        "DEEPAK",
        "दीपक",
        "KISHAN SINGH",
        "किशन सिंह",
        "SUREKHA RANI",
        "Bachelor of Pharmacy",
        "",
        "7.28",
        "First Division",
        "MAY-2025",
        ""
      ],
      [
        "8",
        "21121014",
        "21PS1014",
        "DEEPMALA",
        "दीपमाला",
        "DAYA CHAND",
        "दया चंद",
        "KUSUM DEVI",
        "Bachelor of Pharmacy",
        "",
        "8.42",
        "First Division With Distinction",
        "MAY-2025",
        ""
      ],
      [
        "9",
        "21121015",
        "21PS1015",
        "DISHA",
        "दिशा",
        "HARIDUTT",
        "हरिदत्त",
        "TARUNA",
        "Bachelor of Pharmacy",
        "",
        "9.28",
        "First Division With Distinction",
        "MAY-2025",
        ""
      ],
      [
        "10",
        "21121016",
        "21PS1016",
        "GAURAV",
        "गौरव",
        "ANUP SINGH",
        "अनूप सिंह",
        "SRIWATI",
        "Bachelor of Pharmacy",
        "",
        "9.36",
        "First Division With Distinction",
        "MAY-2025",
        ""
      ],
      [
        "11",
        "21121017",
        "21PS1017",
        "GOPAL",
        "गोपाल",
        "OMPRAKASH",
        "ओमप्रकाश",
        "SUDESH",
        "Bachelor of Pharmacy",
        "",
        "7.11",
        "First Division",
        "MAY-2025",
        ""
      ],
      [
        "12",
        "21121018",
        "21PS1018",
        "GOURAV BAGHEL",
        "गौरव बघेल",
        "JEESUKH",
        "जीसुख",
        "PISTA",
        "Bachelor of Pharmacy",
        "",
        "8.08",
        "First Division With Distinction",
        "MAY-2025",
        ""
      ],
      [
        "13",
        "21121020",
        "21PS1020",
        "GURVINDER SINGH",
        "गुरविंदर सिंह",
        "GURMEET SINGH",
        "गुरमीत सिंह",
        "BALJINDER KAUR",
        "Bachelor of Pharmacy",
        "",
        "9.81",
        "First Division With Distinction",
        "MAY-2025",
        ""
      ],
      [
        "14",
        "21121023",
        "21PS1023",
        "HARIOM SHARMA",
        "हरिओम शर्मा",
        "ABHAYDEV SHARMA",
        "अभयदेव शर्मा",
        "RAJWATI SHARMA",
        "Bachelor of Pharmacy",
        "",
        "7.87",
        "First Division With Distinction",
        "MAY-2025",
        ""
      ],
      [
        "15",
        "21121026",
        "21PS1026",
        "HARSHITA",
        "हर्षिता",
        "DUSHYANT KUMAR",
        "दुष्यंत कुमार",
        "MANJU ",
        "Bachelor of Pharmacy",
        "",
        "9.63",
        "First Division With Distinction",
        "MAY-2025",
        ""
      ],
      [
        "16",
        "21121027",
        "21PS1027",
        "ISHA AGGARWAL",
        "ईशा अग्रवाल",
        "TEKCHAND AGGARWAL",
        "टेकचंद अग्रवाल",
        "REKHA",
        "Bachelor of Pharmacy",
        "",
        "8.52",
        "First Division With Distinction",
        "MAY-2025",
        ""
      ],
      [
        "17",
        "21121031",
        "21PS1031",
        "KUNAL",
        "कुणाल",
        "NARENDER SINGH",
        "नरेंद्र सिंह",
        "KUSUM ",
        "Bachelor of Pharmacy",
        "",
        "7.34",
        "First Division",
        "MAY-2025",
        ""
      ],
      [
        "18",
        "21121032",
        "21PS1032",
        "LALIT",
        "ललित",
        "KUNWAR PAL",
        "कुंवर पाल",
        "DEV WATI",
        "Bachelor of Pharmacy",
        "",
        "7.65",
        "First Division With Distinction",
        "MAY-2025",
        ""
      ],
      [
        "19",
        "21121034",
        "21PS1034",
        "LOKENDER",
        "लोकेंद्र",
        "LILANT KUMAR",
        "लिलंत कुमार",
        "HEMLATA",
        "Bachelor of Pharmacy",
        "",
        "6.79",
        "First Division",
        "MAY-2025",
        ""
      ],
      [
        "20",
        "21121036",
        "21PS1036",
        "PANKAJ SEHRAWAT",
        "पंकज सेहरावत",
        "NARVEER SINGH",
        "नरवीर सिंह",
        "MEENA DEVI",
        "Bachelor of Pharmacy",
        "",
        "7.17",
        "First Division",
        "MAY-2025",
        ""
      ],
      [
        "21",
        "21121042",
        "21PS1042",
        "SACHIN  ",
        "सचिन",
        "INDER SINGH",
        "इंदर सिंह",
        "PUSHPA",
        "Bachelor of Pharmacy",
        "",
        "7.97",
        "First Division With Distinction",
        "MAY-2025",
        ""
      ],
      [
        "22",
        "21121044",
        "21PS1044",
        "SAGAR",
        "सागर",
        "SUNDER SINGH",
        "सुंदर सिंह",
        "LAJWATI DEVI",
        "Bachelor of Pharmacy",
        "",
        "6.89",
        "First Division",
        "SEPTEMBER-2025",
        ""
      ],
      [
        "23",
        "21121045",
        "21PS1045",
        "SANDEEP GAUR",
        "संदीप गौर",
        "SUNIL GAUR",
        "सुनील गौर",
        "GEETA",
        "Bachelor of Pharmacy",
        "",
        "6.94",
        "First Division",
        "SEPTEMBER-2025",
        ""
      ],
      [
        "24",
        "21121046",
        "21PS1046",
        "SAPNA",
        "सपना",
        "RAJU",
        "राजू",
        "KUSUM",
        "Bachelor of Pharmacy",
        "",
        "9.82",
        "First Division With Distinction",
        "MAY-2025",
        ""
      ],
      [
        "25",
        "21121047",
        "21PS1047",
        "SARTHAK KUMAR VERMA",
        "सार्थक कुमार वर्मा",
        "BIRENDRA SINGH",
        "बीरेंद्र सिंह",
        "SAROJ KUMARI",
        "Bachelor of Pharmacy",
        "",
        "8.30",
        "First Division With Distinction",
        "MAY-2025",
        ""
      ],
      [
        "26",
        "21121048",
        "21PS1048",
        "SHIVA KUMAR",
        "शिवा कुमार",
        "PRAMOD KUMAR",
        "प्रमोद कुमार",
        "SONAM",
        "Bachelor of Pharmacy",
        "",
        "8.50",
        "First Division",
        "SEPTEMBER-2025",
        ""
      ],
      [
        "27",
        "21121050",
        "21PS1050",
        "SHREY KAUSHIK",
        "श्रेय कौशिक",
        "SATISH KUMAR",
        "सतीश कुमार",
        "PARUL SHARMA",
        "Bachelor of Pharmacy",
        "",
        "8.60",
        "First Division With Distinction",
        "MAY-2025",
        ""
      ],
      [
        "28",
        "21121051",
        "21PS1051",
        "SUMIT",
        "सुमित",
        "NIRANJAN SINGH",
        "निरंजन सिंह",
        "HARBEJI",
        "Bachelor of Pharmacy",
        "",
        "8.26",
        "First Division With Distinction",
        "MAY-2025",
        ""
      ],
      [
        "29",
        "21121052",
        "21PS1052",
        "SUMIT  ",
        "सुमित",
        "SUKH DEV",
        "सुख देव",
        "OMBATI",
        "Bachelor of Pharmacy",
        "",
        "8.42",
        "First Division With Distinction",
        "MAY-2025",
        ""
      ],
      [
        "30",
        "21121053",
        "21PS1053",
        "SUMIT SINGH",
        "सुमित सिंह",
        "SHIV SINGH",
        "शिव सिंह",
        "MANJU DEVI ",
        "Bachelor of Pharmacy",
        "",
        "9.66",
        "First Division With Distinction",
        "MAY-2025",
        ""
      ],
      [
        "31",
        "21121054",
        "21PS1054",
        "TIKAM",
        "टीकम",
        "ANIL KUMAR",
        "अनिल कुमार",
        "MINAKSHI",
        "Bachelor of Pharmacy",
        "",
        "7.11",
        "First Division",
        "MAY-2025",
        ""
      ],
      [
        "32",
        "21121055",
        "21PS1055",
        "VIKASH",
        "विकास",
        "TEJVIR",
        "तेजवीर",
        "CHANDER WATI",
        "Bachelor of Pharmacy",
        "",
        "7.85",
        "First Division With Distinction",
        "MAY-2025",
        ""
      ],
      [
        "33",
        "21121056",
        "21PS1056",
        "VISHAL",
        "विशाल",
        "JAGVIR",
        "जगवीर",
        "MEENA",
        "Bachelor of Pharmacy",
        "",
        "7.77",
        "First Division",
        "SEPTEMBER-2025",
        ""
      ],
      [
        "34",
        "21121057",
        "21PS1057",
        "VISHAL",
        "विशाल",
        "SABARJEET SINGH",
        "सबरजीत सिंह",
        "BABITA DEVI",
        "Bachelor of Pharmacy",
        "",
        "8.80",
        "First Division With Distinction",
        "MAY-2025",
        ""
      ],
      [
        "35",
        "21121058",
        "21PS1058",
        "VIVEK CHAUHAN",
        "विवेक चौहान",
        "NARESH CHAND",
        "नरेश चंद",
        "POONAM BALA",
        "Bachelor of Pharmacy",
        "",
        "9.05",
        "First Division With Distinction",
        "MAY-2025",
        ""
      ],
      [
        "36",
        "21121060",
        "21PS1060",
        "YOGESH RAWAT",
        "योगेश रावत",
        "UDAY CHAND",
        "उदय चंद",
        "INGLESH",
        "Bachelor of Pharmacy",
        "",
        "7.59",
        "First Division With Distinction",
        "MAY-2025",
        ""
      ],
      [
        "37",
        "21121061",
        "22PS1061/L",
        "GAURAV KUMAR",
        "गौरव कुमार",
        "KRISHAN KUMAR",
        "कृष्ण कुमार",
        "MUNNI DEVI",
        "Bachelor of Pharmacy",
        "",
        "6.88",
        "First Division",
        "MAY-2025",
        ""
      ],
      [
        "38",
        "21121062",
        "22PS1062/L",
        "LUV",
        "लव",
        "YADRAM",
        "याद्रम",
        "GAYATRI",
        "Bachelor of Pharmacy",
        "",
        "8.20",
        "First Division With Distinction",
        "MAY-2025",
        ""
      ],
      [
        "39",
        "21121063",
        "22PS1063/L",
        "MANAV GODARA",
        "मानव गोदारा",
        "ANURAG GODARA",
        "अनुराग गोदारा",
        "KAVITA",
        "Bachelor of Pharmacy",
        "",
        "8.27",
        "First Division With Distinction",
        "MAY-2025",
        ""
      ],
      [
        "40",
        "21121064",
        "22PS1064/L",
        "SACHIN BENIWAL",
        "सचिन बेनीवाल",
        "UDAY SINGH",
        "उदय सिंह",
        "SUDESH KUMARI",
        "Bachelor of Pharmacy",
        "",
        "8.43",
        "First Division With Distinction",
        "MAY-2025",
        ""
      ],
      [
        "41",
        "21121066",
        "22PS1066/L",
        "VIPIN VIKAL",
        "विपिन विकल",
        "AZAD SINGH",
        "आज़ाद सिंह",
        "MUKESH DEVI",
        "Bachelor of Pharmacy",
        "",
        "7.74",
        "First Division With Distinction",
        "MAY-2025",
        ""
      ],
      [
        "42",
        "23125001",
        "23PS5001",
        "NISHA",
        "निशा",
        "JAGDISH",
        "जगदीश",
        "SARLA",
        "Master of Pharmacy",
        "",
        "9.26",
        "First Division With Distinction",
        "OCTOBER-2025",
        ""
      ],
      [
        "43",
        "23125002",
        "23PS5002",
        "MANISH TANWAR",
        "मनीष तंवर",
        "PADAM SINGH TANWAR",
        "पदम सिंह तंवर",
        "ANITA TANWAR",
        "Master of Pharmacy",
        "",
        "7.27",
        "First Division",
        "OCTOBER-2025",
        ""
      ],
      [
        "44",
        "23125003",
        "23PS5003",
        "SOURAV",
        "सौरव",
        "SURENDER",
        "सुरेंद्र",
        "RAJESH",
        "Master of Pharmacy",
        "",
        "7.77",
        "First Division With Distinction",
        "OCTOBER-2025",
        ""
      ],
      [
        "45",
        "23125004",
        "23PS5004",
        "GAURAV CHAUHAN",
        "गौरव चौहान",
        "JASVIR CHAUHAN",
        "जसवीर चौहान",
        "PUSHPA",
        "Master of Pharmacy",
        "",
        "8.27",
        "First Division With Distinction",
        "OCTOBER-2025",
        ""
      ],
      [
        "46",
        "23125006",
        "23PS5006",
        "PRIYANSHU",
        "प्रियांशु",
        "SANJAY SINGLA",
        "संजय सिंगला",
        "KAVITA SINGLA",
        "Master of Pharmacy",
        "",
        "8.63",
        "First Division With Distinction",
        "OCTOBER-2025",
        ""
      ],
      [
        "47",
        "20121021",
        "20PS1021",
        "ROHIT",
        "रोहित",
        "BHAGWAN SINGH",
        "भगवान सिंह",
        "UMESH",
        "Bachelor of Pharmacy",
        "",
        "7.17",
        "First Division",
        "DECEMBER-2024",
        ""
      ],
      [
        "48",
        "20121032",
        "20PS1032",
        "AJIT DAHIYA",
        "अजीत दहिया",
        "NEPAL DAHIYA",
        "नेपाल दहिया",
        "SHASHI",
        "Bachelor of Pharmacy",
        "",
        "7.27",
        "First Division",
        "MAY-2025",
        ""
      ],
      [
        "49",
        "17121056",
        "17PS1056",
        "SHIVAM RAI",
        "शिवम राय",
        "SHIV PRAKASH RAI",
        "शिव प्रकाश राय",
        "CHANDRAKALA RAI",
        "Bachelor of Pharmacy",
        "",
        "6.68",
        "First Division",
        "MAY-2025",
        ""
      ]
    ]
  },
  "Engg. & Tech. Deptt. Degree.": {
    "headers": [
      "SR.\nNo",
      "University Roll Number",
      "REGN. NO.",
      "STUDENT'S NAME",
      "छात्र का नाम",
      "FATHER'S NAME",
      "पिता का नाम",
      "MOTHER'S NAME",
      "Course\n Name ",
      "Stream",
      "CGPA_Print",
      "Division",
      "Session"
    ],
    "rows": [
      [
        "1",
        "21023001",
        "21CS1001",
        "AMIT",
        "अमित",
        "SITARAM",
        "सीताराम",
        "SEEMA",
        "Bachelor of Technology",
        "(Computer Science & Engineering)",
        "8.75",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "2",
        "21023002",
        "21CS1002",
        "AMIT",
        "अमित",
        "SUDHIR KUMAR",
        "सुधीर कुमार",
        "VIBHA DEVI",
        "Bachelor of Technology",
        "(Computer Science & Engineering)",
        "8.45",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "3",
        "21023003",
        "21CS1003",
        "ANIL",
        "अनिल",
        "BALBIR",
        "बलबीर",
        "RAJNI DEVI",
        "Bachelor of Technology",
        "(Computer Science & Engineering)",
        "7.20",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "4",
        "21023004",
        "21CS1004",
        "ANURAG",
        "अनुराग",
        "BISHAMBAR",
        "बिशंभर",
        "DAYAWATI DEVI",
        "Bachelor of Technology",
        "(Computer Science & Engineering)",
        "6.83",
        "First Division",
        "MAY-2025"
      ],
      [
        "5",
        "21023005",
        "21CS1005",
        "ARYAN TANWAR",
        "आर्यन तंवर",
        "KARN DEV TANWAR",
        "कर्ण देव तंवर",
        "MEENU TANWAR",
        "Bachelor of Technology",
        "(Computer Science & Engineering)",
        "6.08",
        "First Division",
        "MAY-2025"
      ],
      [
        "6",
        "21023006",
        "21CS1006",
        "DEVENDER",
        "देवेंद्र",
        "SHYAM LAL",
        "श्याम लाल",
        "SUMAN",
        "Bachelor of Technology",
        "(Computer Science & Engineering)",
        "7.22",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "7",
        "21023007",
        "21CS1007",
        "DEVESH VATS",
        "देवेश वत्स",
        "ASHOK KUMAR",
        "अशोक कुमार",
        "PUSHPA DEVI",
        "Bachelor of Technology",
        "(Computer Science & Engineering)",
        "8.32",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "8",
        "21023008",
        "21CS1008",
        "DUSHYANT SOROUT",
        "दुष्यंत सोरौत",
        "AJAY KUMAR",
        "अजय कुमार",
        "KANTA DEVI",
        "Bachelor of Technology",
        "(Computer Science & Engineering)",
        "7.13",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "9",
        "21023009",
        "21CS1009",
        "GAURAV BHARDWAJ",
        "गौरव भारद्वाज",
        "ANIL KUMAR",
        "अनिल कुमार",
        "ANJU",
        "Bachelor of Technology",
        "(Computer Science & Engineering)",
        "6.11",
        "First Division",
        "MAY-2025"
      ],
      [
        "10",
        "21023010",
        "21CS1010",
        "HANSI SHARMA",
        "हंसी शर्मा",
        "MANOJ SHARMA",
        "मनोज शर्मा",
        "SEEMA SHARMA",
        "Bachelor of Technology",
        "(Computer Science & Engineering)",
        "8.00",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "11",
        "21023011",
        "21CS1011",
        "HARSH",
        "कठोर",
        "UDHAM SINGH",
        "उधम सिंह",
        "LAXMI DEVI",
        "Bachelor of Technology",
        "(Computer Science & Engineering)",
        "7.65",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "12",
        "21023012",
        "21CS1012",
        "KAJAL",
        "काजल",
        "RAJENDER KUMAR",
        "राजेंद्र कुमार",
        "ANITA DEVI",
        "Bachelor of Technology",
        "(Computer Science & Engineering)",
        "8.32",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "13",
        "21023013",
        "21CS1013",
        "KHUSHBOO",
        "खुशबू",
        "LAKHMI SINGH",
        "लक्ष्मी सिंह",
        "MAMTA DEVI",
        "Bachelor of Technology",
        "(Computer Science & Engineering)",
        "7.79",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "14",
        "21023014",
        "21CS1014",
        "KUNSH SUNEJA",
        "कुंश सुनेजा",
        "DHARMENDER SUNEJA",
        "धर्मेंद्र सुनेजा",
        "SHIKHA SUNEJA",
        "Bachelor of Technology",
        "(Computer Science & Engineering)",
        "8.36",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "15",
        "21023015",
        "21CS1015",
        "MISHRI LAL",
        "मिश्री लाल",
        "VED PRAKASH",
        "वेद प्रकाश",
        "SAROJ",
        "Bachelor of Technology",
        "(Computer Science & Engineering)",
        "6.40",
        "First Division",
        "MAY-2025"
      ],
      [
        "16",
        "21023016",
        "21CS1016",
        "MOHIT",
        "मोहित",
        "NAND KUMAR",
        "नंद कुमार",
        "DAYA WATI",
        "Bachelor of Technology",
        "(Computer Science & Engineering)",
        "6.98",
        "First Division",
        "MAY-2025"
      ],
      [
        "17",
        "21023017",
        "21CS1017",
        "MUSKAN KUMARI",
        "मुस्कान कुमारी",
        "RAM VINAY THAKUR",
        "राम विनय ठाकुर",
        "REENA THAKUR",
        "Bachelor of Technology",
        "(Computer Science & Engineering)",
        "8.39",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "18",
        "21023020",
        "21CS1020",
        "PRINCE",
        "राजकुमार",
        "KARMBIR",
        "करमबीर",
        "SUDESH",
        "Bachelor of Technology",
        "(Computer Science & Engineering)",
        "5.26",
        "Second Division",
        "MAY-2025"
      ],
      [
        "19",
        "21023021",
        "21CS1021",
        "RAVI KUMAR",
        "रवि कुमार",
        "BUDHRAM",
        "बुधराम",
        "VIMLA",
        "Bachelor of Technology",
        "(Computer Science & Engineering)",
        "7.98",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "20",
        "21023023",
        "21CS1023",
        "VINAY KUMAR GAUTAM",
        "विनय कुमार गौतम",
        "SH RAJ BAHADUR GAUTAM",
        "श्री राज बहादुर गौतम",
        "SMT SHYAMWATI",
        "Bachelor of Technology",
        "(Computer Science & Engineering)",
        "5.94",
        "Second Division",
        "MAY-2025"
      ],
      [
        "21",
        "21023024",
        "21CS1024",
        "YOGESH",
        "योगेश",
        "ASHOK",
        "अशोक",
        "SURESH",
        "Bachelor of Technology",
        "(Computer Science & Engineering)",
        "6.71",
        "First Division",
        "MAY-2025"
      ],
      [
        "22",
        "21023025",
        "21CS1025",
        "MOHIT KUMAR",
        "मोहित कुमार",
        "LATE PREM KUMAR",
        "स्वर्गीय प्रेम कुमार",
        "LATE BABLI",
        "Bachelor of Technology",
        "(Computer Science & Engineering)",
        "7.57",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "23",
        "21023027",
        "21CS1027",
        "TARUN",
        "तरूण",
        "JILE SINGH",
        "जिले सिंह",
        "SHEELA DEVI",
        "Bachelor of Technology",
        "(Computer Science & Engineering)",
        "7.63",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "24",
        "21023028",
        "21CS1028",
        "CHANCHAL",
        "चंचल",
        "NARESH KUMAR",
        "नरेश कुमार",
        "PRABHA",
        "Bachelor of Technology",
        "(Computer Science & Engineering)",
        "8.44",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "25",
        "21023029",
        "22CS1029/L",
        "CHAMAN",
        "चमन",
        "KARAMVIR",
        "करमवीर",
        "USHA",
        "Bachelor of Technology",
        "(Computer Science & Engineering)",
        "6.74",
        "First Division",
        "MAY-2025"
      ],
      [
        "26",
        "21023030",
        "22CS1030/L",
        "ANUBHUTI MISHRA",
        "अनुभूति मिश्रा",
        "VINAY KUMAR MISHRA",
        "विनय कुमार मिश्रा",
        "SUMAN MISHRA",
        "Bachelor of Technology",
        "(Computer Science & Engineering)",
        "7.40",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "27",
        "21023031",
        "22CS1031/L",
        "RAHUL",
        "राहुल",
        "NARESH KUMAR",
        "नरेश कुमार",
        "PRABHA KUMARI",
        "Bachelor of Technology",
        "(Computer Science & Engineering)",
        "7.88",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "28",
        "22061001",
        "22CA1001",
        "ADITYA BINDAL",
        "आदित्य बिंदल",
        "RAJKUMAR AGGARWAL",
        "राजकुमार अग्रवाल",
        "KAMLESH",
        "Bachelor of Computer Application",
        "",
        "8.97",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "29",
        "22061002",
        "22CA1002",
        "BHAGAT SINGH",
        "भगत सिंह",
        "JOGINDER SINGH",
        "जोगिंदर सिंह",
        "GEETA DEVI",
        "Bachelor of Computer Application",
        "",
        "6.81",
        "First Division",
        "MAY-2025"
      ],
      [
        "30",
        "22061003",
        "22CA1003",
        "CHANCHAL",
        "चंचल",
        "SURESH KUMAR",
        "सुरेश कुमार",
        "KUSUM",
        "Bachelor of Computer Application",
        "",
        "9.00",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "31",
        "22061004",
        "22CA1004",
        "DEVENDER ",
        "देवेंद्र",
        "SANJIV KUMAR",
        "संजीव कुमार",
        "BIMLESH",
        "Bachelor of Computer Application",
        "",
        "8.34",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "32",
        "22061005",
        "22CA1005",
        "DEVENDER ",
        "देवेंद्र",
        "SURENDER",
        "सुरेंद्र",
        "KAVITA DEVI",
        "Bachelor of Computer Application",
        "",
        "7.45",
        "First Division",
        "SEPTEMBER-2025"
      ],
      [
        "33",
        "22061006",
        "22CA1006",
        "GAUTAM SHARMA ",
        "गौतम शर्मा",
        "PREM RAJ ",
        "प्रेम राज",
        "SEEMA",
        "Bachelor of Computer Application",
        "",
        "7.61",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "34",
        "22061007",
        "22CA1007",
        "GEETA",
        "गीता",
        "KRISHAN GOPAL",
        "कृष्ण गोपाल",
        "KAVITA",
        "Bachelor of Computer Application",
        "",
        "8.92",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "35",
        "22061010",
        "22CA1010",
        "KULDEEP SINGH",
        "कुलदीप सिंह",
        "KARAMBIR SINGH",
        "करमबीर सिंह",
        "SARITA SINGH",
        "Bachelor of Computer Application",
        "",
        "6.70",
        "First Division",
        "MAY-2025"
      ],
      [
        "36",
        "22061011",
        "22CA1011",
        "KULDEEPAK",
        "कुलदीपक",
        "OM PRAKASH",
        "ओम प्रकाश",
        "VIJAY WATI",
        "Bachelor of Computer Application",
        "",
        "6.61",
        "First Division",
        "MAY-2025"
      ],
      [
        "37",
        "22061012",
        "22CA1012",
        "LOKESH",
        "लोकेश",
        "NAWAL SINGH",
        "नवल सिंह",
        "BIMLESH",
        "Bachelor of Computer Application",
        "",
        "6.08",
        "First Division",
        "MAY-2025"
      ],
      [
        "38",
        "22061014",
        "22CA1014",
        "OM BERWAL",
        "ओम बेरवाल",
        "DEVENDER SINGH",
        "देवेंद्र सिंह",
        "SAROJ KUMARI",
        "Bachelor of Computer Application",
        "",
        "6.62",
        "First Division",
        "MAY-2025"
      ],
      [
        "39",
        "22061015",
        "22CA1015",
        "PRASHANT",
        "प्रशांत",
        "GHANSHYAM",
        "घनश्याम",
        "MANJU DEVI",
        "Bachelor of Computer Application",
        "",
        "7.45",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "40",
        "22061016",
        "22CA1016",
        "PRASHANT",
        "प्रशांत",
        "KARAMVIR",
        "करमवीर",
        "SUNITA",
        "Bachelor of Computer Application",
        "",
        "5.53",
        "Second Division",
        "SEPTEMBER-2025"
      ],
      [
        "41",
        "22061017",
        "22CA1017",
        "RIYA",
        "रिया",
        "DUSHYANT KUMAR",
        "दुष्यंत कुमार",
        "MANJU",
        "Bachelor of Computer Application",
        "",
        "7.46",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "42",
        "22061019",
        "22CA1019",
        "SONIA",
        "सोनिया",
        "SATPAL",
        "सतपाल",
        "NIRMLA",
        "Bachelor of Computer Application",
        "",
        "6.37",
        "First Division",
        "MAY-2025"
      ],
      [
        "43",
        "22061021",
        "22CA1021",
        "UMANG",
        "उमंग",
        "RANJEET SINGH",
        "रणजीत सिंह",
        "ANITA DEVI",
        "Bachelor of Computer Application",
        "",
        "7.13",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "44",
        "22061022",
        "22CA1022",
        "VISHAL DALAL",
        "विशाल दलाल",
        "FATEH SINGH",
        "फतेह सिंह",
        "DHARAMWATI",
        "Bachelor of Computer Application",
        "",
        "5.91",
        "Second Division",
        "SEPTEMBER-2025"
      ],
      [
        "45",
        "22061025",
        "22CA1025",
        "YOGESH",
        "योगेश",
        "DHARAM CHAND",
        "धरम चंद",
        "SAVITA",
        "Bachelor of Computer Application",
        "",
        "7.33",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "46",
        "22061026",
        "22CA1026",
        "MOIN KHAN",
        "मोइन खान",
        "NASRUDIN",
        "नसरुद्दीन",
        "MARIYAM",
        "Bachelor of Computer Application",
        "",
        "5.44",
        "Second Division",
        "SEPTEMBER-2025"
      ],
      [
        "47",
        "22061027",
        "22CA1027",
        "KUNAL",
        "कुणाल",
        "DINESH KUMAR",
        "दिनेश कुमार",
        "HEMA",
        "Bachelor of Computer Application",
        "",
        "7.21",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "48",
        "22061028",
        "22CA1028",
        "DHRUV DALAL",
        "ध्रुव दलाल",
        "RAM SINGH DALAL",
        "राम सिंह दलाल",
        "MEENA",
        "Bachelor of Computer Application",
        "",
        "6.02",
        "First Division",
        "MAY-2025"
      ],
      [
        "49",
        "22061029",
        "22CA1029",
        "PRADEEP",
        "प्रदीप",
        "DEEP CHAND",
        "दीप चंद",
        "BHIM WATI",
        "Bachelor of Computer Application",
        "",
        "6.09",
        "First Division",
        "MAY-2025"
      ],
      [
        "50",
        "22061030",
        "22CA1030",
        "SALIM KHAN",
        "सलीम खान",
        "RUDDAR KHAN",
        "रूद्दार खान",
        "JAAIDA",
        "Bachelor of Computer Application",
        "",
        "5.69",
        "Second Division",
        "MAY-2025"
      ],
      [
        "51",
        "22061031",
        "22CA1031",
        "MRADUL MOHAN",
        "मृदुल मोहन",
        "RAM VARAN SINGH",
        "राम वरण सिंह",
        "SANGEETA YADAV",
        "Bachelor of Computer Application",
        "",
        "5.43",
        "Second Division",
        "MAY-2025"
      ],
      [
        "52",
        "22061032",
        "22CA1032",
        "VISHAL MOHAN",
        "विशाल मोहन",
        "RAM VARAN SINGH",
        "राम वरण सिंह",
        "SANGEETA YADAV",
        "Bachelor of Computer Application",
        "",
        "6.79",
        "First Division",
        "MAY-2025"
      ]
    ]
  },
  "Agriculture Deptt. Degree ": {
    "headers": [
      "SR.\nNo",
      "University Roll Number",
      "REGN. NO.",
      "STUDENT'S NAME",
      "छात्र का नाम",
      "FATHER'S NAME",
      "पिता का नाम",
      "MOTHER'S NAME",
      "Course\n Name ",
      "Stream",
      "CGPA_Print",
      "Division",
      "Session"
    ],
    "rows": [
      [
        "1",
        "21082001",
        "21BS/AG/1001",
        "AAKASH",
        "आकाश",
        "DEVI RAM",
        "देवी राम",
        "AASHA",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "8.40",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "2",
        "21082002",
        "21BS/AG/1002",
        "AMIT",
        "अमित",
        "RAJU",
        "राजू",
        "SUKANWATI",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "6.16",
        "First Division",
        "MAY-2025"
      ],
      [
        "3",
        "21082004",
        "21BS/AG/1004",
        "AMIT KUMAR",
        "अमित कुमार",
        "KESHAV",
        "केशव",
        "KAVITA",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "6.25",
        "First Division",
        "MAY-2025"
      ],
      [
        "4",
        "21082005",
        "21BS/AG/1005",
        "ANJALI",
        "अंजलि",
        "RAJENDER SINGH",
        "राजेंद्र सिंह",
        "NEERAJ DEVI",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "8.41",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "5",
        "21082006",
        "21BS/AG/1006",
        "ANJALI",
        "अंजलि",
        "LAL CHAND",
        "लाल चंद",
        "BALA DEVI",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "8.21",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "6",
        "21082007",
        "21BS/AG/1007",
        "ANKAN MANDAL",
        "अंकन मंडल",
        "TAPAN KUMAR MANDAL",
        "तपन कुमार मंडल",
        "PURNIMA MANDAL",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "7.37",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "7",
        "21082009",
        "21BS/AG/1009",
        "DEEPAK",
        "दीपक",
        "SHRINIWAS",
        "श्रीनिवास",
        "REKHA",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "6.56",
        "First Division",
        "MAY-2025"
      ],
      [
        "8",
        "21082010",
        "21BS/AG/1010",
        "DEV RAWAT",
        "देव रावत",
        "RAJENDER",
        "राजेन्द्र",
        "BABITA",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "5.91",
        "Second Division",
        "MAY-2025"
      ],
      [
        "9",
        "21082013",
        "21BS/AG/1013",
        "KAJAL",
        "काजल",
        "VISHRAM",
        "विश्राम",
        "ANITA DEVI",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "8.02",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "10",
        "21082014",
        "21BS/AG/1014",
        "KAPIL SHARMA",
        "कपिल शर्मा",
        "SATISH KUMAR",
        "सतीश कुमार",
        "MANISHA",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "6.01",
        "First Division",
        "MAY-2025"
      ],
      [
        "11",
        "21082015",
        "21BS/AG/1015",
        "KHUSHBU",
        "खुशबु",
        "SUKHRAM",
        "सुखराम",
        "SHIMLA",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "7.73",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "12",
        "21082016",
        "21BS/AG/1016",
        "KUNAL",
        "कुणाल",
        "MAHIPAL",
        "महिपाल",
        "SAVITA",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "6.70",
        "First Division",
        "MAY-2025"
      ],
      [
        "13",
        "21082017",
        "21BS/AG/1017",
        "LALIT KUMAR",
        "ललित कुमार",
        "GOPAL SINGH",
        "गोपाल सिंह",
        "VEERBATI DEVI",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "5.89",
        "Second Division",
        "MAY-2025"
      ],
      [
        "14",
        "21082018",
        "21BS/AG/1018",
        "LALIT SEHRAWAT",
        "ललित सेहरावत",
        "ASHOK KUMAR",
        "अशोक कुमार",
        "NITESH",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "6.45",
        "First Division",
        "MAY-2025"
      ],
      [
        "15",
        "21082021",
        "21BS/AG/1021",
        "MANJEET",
        "मनजीत",
        "RAJENDER",
        "राजेन्द्र",
        "PUSHPA",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "5.94",
        "Second Division",
        "MAY-2025"
      ],
      [
        "16",
        "21082022",
        "21BS/AG/1022",
        "MOIN KHAN",
        "मोइन खान",
        "SPAT KHAN",
        "स्पात खान",
        "HAMIDAN",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "6.03",
        "First Division",
        "MAY-2025"
      ],
      [
        "17",
        "21082023",
        "21BS/AG/1023",
        "NAVEEN",
        "नवीन",
        "ASHOK",
        "अशोक",
        "INDERWATI",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "7.81",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "18",
        "21082024",
        "21BS/AG/1024",
        "NEHA",
        "नेहा",
        "CHARAN SINGH",
        "चरण सिंह",
        "MEENA",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "8.27",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "19",
        "21082026",
        "21BS/AG/1026",
        "NIKHIL",
        "निखिल",
        "VIJAYPAL",
        "विजयपाल",
        "SUMANTRA",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "6.26",
        "First Division",
        "MAY-2025"
      ],
      [
        "20",
        "21082028",
        "21BS/AG/1028",
        "OMBEER CHAUDHARY",
        "ओमबीर चौधरी",
        "KISHAN SAHAI",
        "किशन सहाय",
        "DHARAM BATI",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "5.84",
        "Second Division",
        "MAY-2025"
      ],
      [
        "21",
        "21082029",
        "21BS/AG/1029",
        "RAKHI",
        "राखी",
        "BIJENDER SINGH",
        "बिजेन्द्र सिंह",
        "REKHA",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "8.47",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "22",
        "21082030",
        "21BS/AG/1030",
        "RAKIB KHAN",
        "रकीब खान",
        "UMAR MOHD",
        "उमर मोहम्मद",
        "FARIDA",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "6.33",
        "First Division",
        "MAY-2025"
      ],
      [
        "23",
        "21082032",
        "21BS/AG/1032",
        "ROCKY",
        "चट्टान का",
        "RAJESH DESHWAL",
        "राजेश देशवाल",
        "GEETA",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "5.94",
        "Second Division",
        "MAY-2025"
      ],
      [
        "24",
        "21082034",
        "21BS/AG/1034",
        "SACHIN",
        "सचिन",
        "HARICHAND",
        "हरीचंद",
        "LAXMI",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "7.28",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "25",
        "21082035",
        "21BS/AG/1035",
        "SAGAR",
        "सागर",
        "MOHAN SINGH",
        "मोहन सिंह",
        "PUSPA DEVI",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "6.91",
        "First Division",
        "MAY-2025"
      ],
      [
        "26",
        "21082036",
        "21BS/AG/1036",
        "SAHIL VASHISTH",
        "साहिल वशिष्ठ",
        "RAKESH KUMAR",
        "राकेश कुमार",
        "PREMLATA",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "6.02",
        "First Division",
        "MAY-2025"
      ],
      [
        "27",
        "21082038",
        "21BS/AG/1038",
        "SAHIN KHAN",
        "साहिन खान",
        "SOKAT ALI",
        "सोकत अली",
        "SAHIDA",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "5.96",
        "Second Division",
        "MAY-2025"
      ],
      [
        "28",
        "21082039",
        "21BS/AG/1039",
        "SAKSHI",
        "साक्षी",
        "KAMAL SINGH",
        "कमल सिंह",
        "DARSHAN",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "8.23",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "29",
        "21082040",
        "21BS/AG/1040",
        "SANDEEP",
        "संदीप",
        "RAMDUTT",
        "रामदत्त",
        "JAGWATI",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "7.94",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "30",
        "21082041",
        "21BS/AG/1041",
        "SHAHID",
        "शाहिद",
        "RAHMU",
        "रहमू",
        "ASMINA",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "5.52",
        "Second Division",
        "MAY-2025"
      ],
      [
        "31",
        "21082042",
        "21BS/AG/1042",
        "SHEETAL SHARMA",
        "शीतल शर्मा",
        "MAHESH SHARMA",
        "महेश शर्मा",
        "USHA",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "6.78",
        "First Division",
        "MAY-2025"
      ],
      [
        "32",
        "21082044",
        "21BS/AG/1044",
        "SHIVAM SOROUT",
        "शिवम सोरौत",
        "MAHENDER SINGH",
        "महेंद्र सिंह",
        "SATESH",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "5.56",
        "Second Division",
        "MAY-2025"
      ],
      [
        "33",
        "21082045",
        "21BS/AG/1045",
        "SUPRIYA RAUT",
        "सुप्रिया राउत",
        "ARUN RAUT",
        "अरुण राउत",
        "NAMITA RAUT",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "7.49",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "34",
        "21082046",
        "21BS/AG/1046",
        "TANNU",
        "तन्नू",
        "NARENDERA",
        "नरेन्द्र",
        "MAMTA",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "7.63",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "35",
        "21082049",
        "21BS/AG/1049",
        "YASHPAL",
        "यशपाल",
        "MANPHOOL",
        "मनफूल",
        "ANITA",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "7.11",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "36",
        "21082051",
        "21BS/AG/1051",
        "DIVYANSHU",
        "दिव्यांशु",
        "ANIL KUMAR",
        "अनिल कुमार",
        "LAXMI DEVI",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "7.27",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "37",
        "21082052",
        "21BS/AG/1052",
        "LALIT KUMAR",
        "ललित कुमार",
        "ROOP SINGH",
        "रूप सिंह",
        "PUSHPA",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "6.94",
        "First Division",
        "MAY-2025"
      ],
      [
        "38",
        "21082053",
        "21BS/AG/1053",
        "RASHMI",
        "रश्मि",
        "KAMAL SINGH",
        "कमल सिंह",
        "JALWATI",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "8.02",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "39",
        "21082054",
        "21BS/AG/1054",
        "UMESH",
        "उमेश",
        "VIJAYPAL",
        "विजयपाल",
        "NEELAM",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "6.84",
        "First Division",
        "MAY-2025"
      ],
      [
        "40",
        "21082057",
        "21BS/AG/1057",
        "AAMIR KHAN",
        "आमिर खान",
        "ABDUL GANI",
        "अब्दुल गनी",
        "MARYAM",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "5.79",
        "Second Division",
        "MAY-2025"
      ],
      [
        "41",
        "21082058",
        "21BS/AG/1058",
        "MOHIT",
        "मोहित",
        "JAGAT SINGH",
        "जगत सिंह",
        "MUKESH",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "6.13",
        "First Division",
        "MAY-2025"
      ],
      [
        "42",
        "21082059",
        "21BS/AG/1059",
        "SALEEM KHAN",
        "सलीम खान",
        "JAMIL KHAN",
        "जमील खान",
        "KHATUNI",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "6.03",
        "First Division",
        "MAY-2025"
      ],
      [
        "43",
        "21082060",
        "21BS/AG/1060",
        "DEEPTI SHARMA",
        "दीप्ति शर्मा",
        "SANJAY SHARMA",
        "संजय शर्मा",
        "SUMAN SHARMA",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "7.07",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "44",
        "21082061",
        "21BS/AG/1061",
        "PARVEJ KHAN",
        "परवेज खान",
        "HASAN MOHD",
        "हसन मोहम्मद",
        "ASMINA",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "7.33",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "45",
        "21082062",
        "21BS/AG/1062",
        "PARMOD",
        "प्रमोद",
        "RAVI DUTT",
        "रवि दत्त",
        "KUNTI DEVI",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "6.63",
        "First Division",
        "MAY-2025"
      ],
      [
        "46",
        "21082063",
        "21BS/AG/1063",
        "AAMIR KHAN",
        "आमिर खान",
        "FAIYAZ KHAN",
        "फैयाज खान",
        "ROSHANI",
        "Bachelor of Science  (Honours)",
        "Agriculture",
        "6.08",
        "First Division",
        "MAY-2025"
      ]
    ]
  },
  "AHS": {
    "headers": [
      "SR.\nNo",
      "University Roll Number",
      "REGN. NO.",
      "STUDENT'S NAME",
      "छात्र का नाम",
      "FATHER'S NAME",
      "पिता का नाम",
      "MOTHER'S NAME",
      "Course\n Name ",
      "CGPA_Print",
      "Division",
      "Session"
    ],
    "rows": [
      [
        "1",
        "22083001",
        "22BS/ML/1001",
        "ARUN SHARMA",
        "अरुण शर्मा",
        "VED RAM",
        "वेद राम",
        "PINKI",
        "Bachelor of Science in Medical Laboratory Technology",
        "6.59",
        "First Division",
        "MAY-2025"
      ],
      [
        "2",
        "22083003",
        "22BS/ML/1003",
        "BHAWNA",
        "भावना",
        "JOGENDER",
        "जोगेंडर",
        "DHARAMVATI",
        "Bachelor of Science in Medical Laboratory Technology",
        "8.79",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "3",
        "22083005",
        "22BS/ML/1005",
        "CHANCHAL",
        "चंचल",
        "TEEKA RAM",
        "टीका राम",
        "MOHAN BALA",
        "Bachelor of Science in Medical Laboratory Technology",
        "9.40",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "4",
        "22083008",
        "22BS/ML/1008",
        "JAIVEER",
        "जयवीर",
        "DEVENDER",
        "देवेंद्र",
        "RAJBALA",
        "Bachelor of Science in Medical Laboratory Technology",
        "6.69",
        "First Division",
        "MAY-2025"
      ],
      [
        "5",
        "22083009",
        "22BS/ML/1009",
        "LOKESH",
        "लोकेश",
        "JAI SINGH",
        "जय सिंह",
        "POONAM",
        "Bachelor of Science in Medical Laboratory Technology",
        "6.60",
        "First Division",
        "MAY-2025"
      ],
      [
        "6",
        "22083010",
        "22BS/ML/1010",
        "MADHU ",
        "मधु",
        "HUKAM",
        "हुकम",
        "SHARMILA",
        "Bachelor of Science in Medical Laboratory Technology",
        "7.73",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "7",
        "22083011",
        "22BS/ML/1011",
        "MEHAK LAMBA",
        "महक लांबा",
        "RAJESH LAMBA",
        "राजेश लांबा",
        "PINKI",
        "Bachelor of Science in Medical Laboratory Technology",
        "8.31",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "8",
        "22083012",
        "22BS/ML/1012",
        "NAZRANA",
        "नज़राना",
        "IBRAHIM",
        "इब्राहिम",
        "RAJUNI",
        "Bachelor of Science in Medical Laboratory Technology",
        "6.90",
        "First Division",
        "MAY-2025"
      ],
      [
        "9",
        "22083013",
        "22BS/ML/1013",
        "NOSHAD",
        "नोशाद",
        "FARUKH",
        "फारुख",
        "JAUBUNA",
        "Bachelor of Science in Medical Laboratory Technology",
        "5.81",
        "Second Division",
        "MAY-2025"
      ],
      [
        "10",
        "22083014",
        "22BS/ML/1014",
        "PRINCI SHARMA",
        "प्रिंसी शर्मा",
        "RAM KUMAR",
        "राम कुमार",
        "YOG MAYA",
        "Bachelor of Science in Medical Laboratory Technology",
        "8.97",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "11",
        "22083015",
        "22BS/ML/1015",
        "RAHUL",
        "राहुल",
        "BHAGAT SINGH",
        "भगत सिंह",
        "ANJU",
        "Bachelor of Science in Medical Laboratory Technology",
        "6.47",
        "First Division",
        "MAY-2025"
      ],
      [
        "12",
        "22083017",
        "22BS/ML/1017",
        "SAKIB HUSSAIN",
        "साकिब हुसैन",
        "MOHD ASLAM",
        "मोहम्मद असलम",
        "BASSI",
        "Bachelor of Science in Medical Laboratory Technology",
        "5.14",
        "Second Division",
        "MAY-2025"
      ],
      [
        "13",
        "22083020",
        "22BS/ML/1020",
        "SHAKSHI",
        "शाक्षी",
        "VINOD KUMAR",
        "विनोद कुमार",
        "KOSHAL",
        "Bachelor of Science in Medical Laboratory Technology",
        "6.66",
        "First Division",
        "MAY-2025"
      ],
      [
        "14",
        "22083021",
        "22BS/ML/1021",
        "SOHEL KHAN",
        "सोहेल खान",
        "MUKIM",
        "मुकीम",
        "AARSTUN",
        "Bachelor of Science in Medical Laboratory Technology",
        "4.94",
        "Second Division",
        "MAY-2025"
      ],
      [
        "15",
        "22083022",
        "22BS/ML/1022",
        "SONAM",
        "सोनम",
        "BRAHMPAL",
        "ब्रह्मपाल",
        "GEETA",
        "Bachelor of Science in Medical Laboratory Technology",
        "7.24",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "16",
        "22083023",
        "22BS/ML/1023",
        "TAMNNA",
        "तमन्ना",
        "NARENDER",
        "नरेंदर",
        "RAVITA",
        "Bachelor of Science in Medical Laboratory Technology",
        "6.40",
        "First Division",
        "MAY-2025"
      ],
      [
        "17",
        "22083024",
        "22BS/ML/1024",
        "TAPISH",
        "तपिश",
        "KEHAR SINGH",
        "केहर सिंह",
        "NEELAM",
        "Bachelor of Science in Medical Laboratory Technology",
        "8.23",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "18",
        "22083026",
        "22BS/ML/1026",
        "UMESH",
        "उमेश",
        "BIR SINGH",
        "बीर सिंह",
        "MAYA",
        "Bachelor of Science in Medical Laboratory Technology",
        "5.60",
        "Second Division",
        "MAY-2025"
      ],
      [
        "19",
        "22083027",
        "22BS/ML/1027",
        "UTTAM SINGH",
        "उत्तम सिंह",
        "DEVI LAL",
        "देवी लाल",
        "PUSHPA",
        "Bachelor of Science in Medical Laboratory Technology",
        "6.94",
        "First Division",
        "SEPTEMBER-2025"
      ],
      [
        "20",
        "22083028",
        "23BS/ML/1028/L",
        "ROHIT SOROUT",
        "रोहित सोरौत",
        "SURENDER SINGH",
        "सुरेंद्र सिंह",
        "DHARAM WATI",
        "Bachelor of Science in Medical Laboratory Technology",
        "6.91",
        "First Division",
        "MAY-2025"
      ],
      [
        "21",
        "22083029",
        "23BS/ML/1029/L",
        "RENU KUMARI",
        "रेनू कुमारी",
        "GIRRAJ SINGH",
        "गिर्राज सिंह",
        "NEERAJ DEVI",
        "Bachelor of Science in Medical Laboratory Technology",
        "9.14",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "22",
        "22083030",
        "23BS/ML/1030/L",
        "NIDHI",
        "निधि",
        "SANJAY KUMAR",
        "संजय कुमार",
        "SUMAN",
        "Bachelor of Science in Medical Laboratory Technology",
        "8.46",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "23",
        "22083031",
        "23BS/ML/1031/L",
        "MONIKA",
        "मोनिका",
        "DALCHAND",
        "डालचंद",
        "JAIWATI",
        "Bachelor of Science in Medical Laboratory Technology",
        "7.60",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "24",
        "22083032",
        "23BS/ML/1032/L",
        "PRINCE SOROUT",
        "प्रिंस सोरौट",
        "RAJ SINGH",
        "राज सिंह",
        "HEMLATA",
        "Bachelor of Science in Medical Laboratory Technology",
        "6.34",
        "First Division",
        "MAY-2025"
      ],
      [
        "25",
        "21083035",
        "22BS/ML/1035/L",
        "AKEEL AHMED",
        "अकील अहमद",
        "MOHD IQBAL",
        "मोहम्मद इकबाल",
        "RIHANA",
        "Bachelor of Science in Medical Laboratory Technology",
        "4.93",
        "Second Division",
        "SEPTEMBER-2025"
      ],
      [
        "26",
        "21083036",
        "22BS/ML/1036/L",
        "FAIZ AHMED",
        "फैज़ अहमद",
        "AIZAZ AHMED",
        "ऐजाज़ अहमद",
        "AMINA",
        "Bachelor of Science in Medical Laboratory Technology",
        "5.31",
        "Second Division",
        "SEPTEMBER-2025"
      ],
      [
        "27",
        "22086001",
        "22BS/BT/1001",
        "ARYAN  SHARMA",
        "आर्यन शर्मा",
        "ANURAG SHARMA",
        "अनुराग शर्मा",
        "NEERAJ",
        "Bachelor of Science in Biotechnology",
        "5.53",
        "Second Division",
        "SEPTEMBER-2025"
      ],
      [
        "28",
        "22086002",
        "22BS/BT/1002",
        "ASHMIT SHARMA",
        "अश्मित शर्मा",
        "SANJAY KUMAR SHARMA",
        "संजय कुमार शर्मा",
        "ANUPMA SHARMA",
        "Bachelor of Science in Biotechnology",
        "6.93",
        "First Division",
        "SEPTEMBER-2025"
      ],
      [
        "29",
        "22086003",
        "22BS/BT/1003",
        "BHAWANA TANWAR",
        "भावना तंवर",
        "NARESH",
        "नरेश",
        "SUNITA",
        "Bachelor of Science in Biotechnology",
        "6.93",
        "First Division",
        "MAY-2025"
      ],
      [
        "30",
        "22086005",
        "22BS/BT/1005",
        "JITENDER",
        "जितेन्द्र",
        "CHATTER PAL SAINI",
        "चत्तर पाल सैनी",
        "BALA",
        "Bachelor of Science in Biotechnology",
        "7.34",
        "First Division",
        "SEPTEMBER-2025"
      ],
      [
        "31",
        "22086006",
        "22BS/BT/1006",
        "JUHI DIXIT",
        "जूही दीक्षित",
        "MANOJ KUMAR",
        "मनोज कुमार",
        "MAHESH DEVI",
        "Bachelor of Science in Biotechnology",
        "7.41",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "32",
        "22086007",
        "22BS/BT/1007",
        "JYOTI",
        "ज्योति",
        "PREM CHAND",
        "प्रेम चंद",
        "MEENA",
        "Bachelor of Science in Biotechnology",
        "7.17",
        "First Division",
        "SEPTEMBER-2025"
      ],
      [
        "33",
        "22086008",
        "22BS/BT/1008",
        "KHUSHI DAHIYA",
        "ख़ुशी दहिया",
        "SANDEEP KUMAR",
        "संदीप कुमार",
        "JAI SHREE",
        "Bachelor of Science in Biotechnology",
        "8.46",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "34",
        "22086009",
        "22BS/BT/1009",
        "KOMAL",
        "कोमल",
        "GAJRAJ",
        "गजराज",
        "REKHA",
        "Bachelor of Science in Biotechnology",
        "6.96",
        "First Division",
        "MAY-2025"
      ],
      [
        "35",
        "22086010",
        "22BS/BT/1010",
        "KOMAL",
        "कोमल",
        "VIRENDER SINGH",
        "वीरेंद्र सिंह",
        "MURTI DEVI",
        "Bachelor of Science in Biotechnology",
        "6.83",
        "First Division",
        "MAY-2025"
      ],
      [
        "36",
        "22086011",
        "22BS/BT/1011",
        "MANISHA DEVI",
        "मनीषा देवी",
        "PRATAP SINGH",
        "प्रताप सिंह",
        "MITHLESH",
        "Bachelor of Science in Biotechnology",
        "7.50",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "37",
        "22086012",
        "22BS/BT/1012",
        "PRIYA",
        "प्रिया",
        "HARI CHAND",
        "हरि चंद",
        "PAPITA",
        "Bachelor of Science in Biotechnology",
        "6.87",
        "First Division",
        "MAY-2025"
      ],
      [
        "38",
        "22086014",
        "22BS/BT/1014",
        "SIDHARTH",
        "सिद्धार्थ",
        "RAJESH",
        "राजेश",
        "SUNITA",
        "Bachelor of Science in Biotechnology",
        "6.69",
        "First Division",
        "SEPTEMBER-2025"
      ],
      [
        "39",
        "22086015",
        "22BS/BT/1015",
        "VANSHIKA",
        "वंशिका",
        "AJAY",
        "अजय",
        "KAVITA",
        "Bachelor of Science in Biotechnology",
        "8.60",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "40",
        "22084002",
        "22BS/MM/1002",
        "KIRTI",
        "कीर्ति",
        "JOGENDER",
        "जोगेंद्र",
        "KAMLESH",
        "Bachelor of Science in Medical Microbiology",
        "7.24",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "41",
        "22084003",
        "22BS/MM/1003",
        "AMAR POSWAL",
        "अमर पोसवाल",
        "OMPAL POSWAL",
        "ओमपाल पोसवाल",
        "KAVITA POSWAL",
        "Bachelor of Science in Medical Microbiology",
        "5.60",
        "First Division",
        "MAY-2025"
      ],
      [
        "42",
        "23085001",
        "23BS/MB/5001",
        "ANCHAL",
        "आँचल",
        "DAL CHAND",
        "दाल चंद",
        "SAVITRI",
        "Master of Science in Microbiology",
        "8.24",
        "First Division With Distinction",
        "SEPTEMBER-2025"
      ],
      [
        "43",
        "23085002",
        "23BS/MB/5002",
        "KOMAL",
        "कोमल",
        "CHANDERVESH",
        "चंद्रवेश",
        "LAXMI DEVI",
        "Master of Science in Microbiology",
        "8.47",
        "First Division With Distinction",
        "SEPTEMBER-2025"
      ],
      [
        "44",
        "23085003",
        "23BS/MB/5003",
        "NEHA",
        "नेहा",
        "TAJENDER",
        "तजेंद्र",
        "SEEMA",
        "Master of Science in Microbiology",
        "8.31",
        "First Division With Distinction",
        "SEPTEMBER-2025"
      ],
      [
        "45",
        "23085004",
        "23BS/MB/5004",
        "PRAMOD",
        "प्रमोद",
        "PREM SINGH",
        "प्रेम सिंह",
        "SUKAN",
        "Master of Science in Microbiology",
        "6.09",
        "First Division",
        "SEPTEMBER-2025"
      ],
      [
        "46",
        "23085005",
        "23BS/MB/5005",
        "SAPANA",
        "सपना",
        "BHIM SINGH",
        "भीम सिंह",
        "GAJANA",
        "Master of Science in Microbiology",
        "8.22",
        "First Division With Distinction",
        "SEPTEMBER-2025"
      ],
      [
        "47",
        "23085006",
        "23BS/MB/5006",
        "ROKI",
        "रोकी",
        "RAKESH KUMAR",
        "राकेश कुमार",
        "MUKESH",
        "Master of Science in Microbiology",
        "7.07",
        "First Division With Distinction",
        "SEPTEMBER-2025"
      ],
      [
        "48",
        "23085008",
        "23BS/MB/5008",
        "AAKASH",
        "आकाश",
        "SUNIL",
        "सुनील",
        "MAMTA",
        "Master of Science in Microbiology",
        "7.22",
        "First Division With Distinction",
        "SEPTEMBER-2025"
      ],
      [
        "49",
        "23085010",
        "23BS/MB/5010",
        "PANKAJ SHARMA",
        "पंकज शर्मा",
        "MUKESH SHARMA",
        "मुकेश शर्मा",
        "YOGENDRI DEVI",
        "Master of Science in Microbiology",
        "7.27",
        "First Division With Distinction",
        "SEPTEMBER-2025"
      ],
      [
        "50",
        "23085011",
        "23BS/MB/5011",
        "LALITA",
        "ललिता",
        "MOHAN SHYAM",
        "मोहन श्याम",
        "MUKESH DEVI",
        "Master of Science in Microbiology",
        "8.40",
        "First Division With Distinction",
        "SEPTEMBER-2025"
      ],
      [
        "51",
        "23085012",
        "23BS/MB/5012",
        "MANISHA",
        "मनीषा",
        "SHIVRAM",
        "शिवराम",
        "SHEELA DEVI",
        "Master of Science in Microbiology",
        "7.09",
        "First Division With Distinction",
        "SEPTEMBER-2025"
      ],
      [
        "52",
        "20151001",
        "20BP1001",
        "AARTI",
        "आरती",
        "BHAGAT SINGH",
        "भगत सिंह",
        "KUSUM",
        "Bachelor of Physiotherapy",
        "6.97",
        "First Division",
        "MAY-2024"
      ],
      [
        "53",
        "20151002",
        "20BP1002",
        "ANURAG",
        "अनुराग",
        "SHASHI",
        "शशि",
        "MEENAKSHI",
        "Bachelor of Physiotherapy",
        "6.92",
        "First Division",
        "MAY-2024"
      ],
      [
        "54",
        "20151003",
        "20BP1003",
        "DALVEER",
        "दलवीर",
        "KISHAN",
        "किशन",
        "ASHA",
        "Bachelor of Physiotherapy",
        "7.36",
        "First Division With Distinction",
        "MAY-2024"
      ],
      [
        "55",
        "20151007",
        "20BP1007",
        "SANGEETA MATHPAL",
        "संगीता मथपाल",
        "MOHAN CHANDER",
        "मोहन चंदर",
        "VEENA DEVI",
        "Bachelor of Physiotherapy",
        "6.68",
        "First Division",
        "MAY-2024"
      ],
      [
        "56",
        "20151008",
        "20BP1008",
        "SUMITI SHARMA",
        "सुमिति शर्मा",
        "SATYA PRAKASH",
        "सत्य प्रकाश",
        "SEEMA",
        "Bachelor of Physiotherapy",
        "7.58",
        "First Division With Distinction",
        "MAY-2024"
      ],
      [
        "57",
        "20151009",
        "20BP1009",
        "VARSHA",
        "वर्षा",
        "SURENDER SINGH",
        "सुरेंद्र सिंह",
        "USHA DEVI",
        "Bachelor of Physiotherapy",
        "7.85",
        "First Division With Distinction",
        "MAY-2024"
      ],
      [
        "58",
        "20151010",
        "20BP1010",
        "VIPESH",
        "विपेश",
        "SATISH KUMAR",
        "सतीश कुमार",
        "RAJ BALA",
        "Bachelor of Physiotherapy",
        "7.70",
        "First Division With Distinction",
        "MAY-2024"
      ],
      [
        "59",
        "20151012",
        "20BP1012",
        "MANISHA",
        "मनीषा",
        "SHIV KUMAR",
        "शिव कुमार",
        "ANITA",
        "Bachelor of Physiotherapy",
        "8.24",
        "First Division With Distinction",
        "MAY-2024"
      ],
      [
        "60",
        "20151013",
        "20BP1013",
        "ANJALI",
        "अंजलि",
        "RAJESH",
        "राजेश",
        "KAUSHLYA",
        "Bachelor of Physiotherapy",
        "7.93",
        "First Division With Distinction",
        "MAY-2024"
      ],
      [
        "61",
        "20151015",
        "20BP1015",
        "MONIKA",
        "मोनिका",
        "RAJPAL",
        "राजपाल",
        "KRISHNA",
        "Bachelor of Physiotherapy",
        "7.65",
        "First Division With Distinction",
        "MAY-2024"
      ],
      [
        "62",
        "20151016",
        "20BP1016",
        "KAPIL",
        "कपिल",
        "MAHESH",
        "महेश",
        "MANJU",
        "Bachelor of Physiotherapy",
        "6.99",
        "First Division",
        "MAY-2024"
      ],
      [
        "63",
        "20151017",
        "20BP1017",
        "RAMAN KUMAR",
        "रमन कुमार",
        "VIJAY PAL",
        "विजय पाल",
        "SATANWATI",
        "Bachelor of Physiotherapy",
        "6.40",
        "First Division",
        "MAY-2024"
      ],
      [
        "64",
        "20151018",
        "20BP1018",
        "MANISH",
        "मनीष",
        "MOHAN SINGH",
        "मोहन सिंह",
        "RAJKUMARI",
        "Bachelor of Physiotherapy",
        "7.23",
        "First Division With Distinction",
        "MAY-2024"
      ],
      [
        "65",
        "20151019",
        "20BP1019",
        "AKASH RAWAT",
        "आकाश रावत",
        "BIKRAM SINGH RAWAT",
        "बिक्रम सिंह रावत",
        "SUNDRI RAWAT",
        "Bachelor of Physiotherapy",
        "7.45",
        "First Division With Distinction",
        "MAY-2024"
      ],
      [
        "66",
        "20151021",
        "20BP1021",
        "USHA",
        "उषा",
        "RAMBIR",
        "रामबीर",
        "KIRAN DEVI",
        "Bachelor of Physiotherapy",
        "6.97",
        "First Division",
        "MAY-2024"
      ],
      [
        "67",
        "20151022",
        "20BP1022",
        "RAINA",
        "रैना",
        "CHANDER SINGH JAKHAR",
        "चंदर सिंह जाखड़",
        "ASHA",
        "Bachelor of Physiotherapy",
        "7.11",
        "First Division With Distinction",
        "MAY-2024"
      ],
      [
        "68",
        "20151023",
        "20BP1023",
        "SEEMA SHARMA",
        "सीमा शर्मा",
        "VIJAY KUMAR",
        "विजय कुमार",
        "JAYWATI",
        "Bachelor of Physiotherapy",
        "7.42",
        "First Division With Distinction",
        "MAY-2024"
      ],
      [
        "69",
        "19151020",
        "19BP1020",
        "DILSAR KHAN",
        "दिलसार खान",
        "RAHIMUDDIN KHAN",
        "रहीमुद्दीन खान",
        "RASIDAN BANO",
        "Bachelor of Physiotherapy",
        "4.97",
        "Second Division",
        "SEPTEMBER-2024"
      ]
    ]
  },
  "DIPLMA IN PHARMACY": {
    "headers": [
      "SR.\nNo",
      "University Roll Number",
      "REGN. NO.",
      "STUDENT'S NAME",
      "छात्र का नाम",
      "FATHER'S NAME",
      "पिता का नाम",
      "MOTHER'S NAME",
      "Course\n Name ",
      "Stream",
      "Total Marks",
      "Obt. Marks",
      "Per%",
      "Division",
      "Session"
    ],
    "rows": [
      [
        "1",
        "23141001",
        "23PS001",
        "AASIF",
        "आसिफ",
        "ISMAIL KHAN",
        "इस्माइल खान",
        "KAMALBI",
        "DIPLOMA IN PHARMACY",
        "",
        "2100",
        "1338",
        "63.714285714285715",
        "First Division",
        "MAY-2025"
      ],
      [
        "2",
        "23141002",
        "23PS002",
        "AJAY",
        "अजय",
        "CHARAN",
        "चरण",
        "SUNITA",
        "DIPLOMA IN PHARMACY",
        "",
        "2100",
        "1432",
        "68.19047619047619",
        "First Division",
        "MAY-2025"
      ],
      [
        "3",
        "23141003",
        "23PS003",
        "AMAN ",
        "अमन",
        "KISHAN SINGH",
        "किशन सिंह",
        "SEEMA",
        "DIPLOMA IN PHARMACY",
        "",
        "2100",
        "1352",
        "64.38095238095238",
        "First Division",
        "MAY-2025"
      ],
      [
        "4",
        "23141004",
        "23PS004",
        "ANJALI",
        "अंजलि",
        "SUDHIR SINGH",
        "सुधीर सिंह",
        "AKASH",
        "DIPLOMA IN PHARMACY",
        "",
        "2100",
        "1913",
        "91.0952380952381",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "5",
        "23141005",
        "23PS005",
        "ANJNA",
        "अंजना",
        "TULSIRAM",
        "तुलसीराम",
        "ANITA",
        "DIPLOMA IN PHARMACY",
        "",
        "2100",
        "1950",
        "92.85714285714286",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "6",
        "23141006",
        "23PS006",
        "BUNTY GURJAR",
        "बंटी गुर्जर",
        "SUKHBIR SINGH",
        "सुखबीर सिंह",
        "MEENA DEVI",
        "DIPLOMA IN PHARMACY",
        "",
        "2100",
        "1130",
        "53.80952380952381",
        "PASS Division",
        "MAY-2025"
      ],
      [
        "7",
        "23141008",
        "23PS008",
        "CHANDER KANT",
        "चंद्रकांत",
        "TRILOK CHAND",
        "त्रिलोक चंद",
        "SUMAN DEVI",
        "DIPLOMA IN PHARMACY",
        "",
        "2100",
        "1379",
        "65.66666666666667",
        "PASS Division",
        "SEPTEMBER-2025"
      ],
      [
        "8",
        "23141010",
        "23PS010",
        "ESHAN GAUTAM",
        "ईशान गौतम",
        "ASHWANI KUMAR GAUTAM",
        "अश्वनी कुमार गौतम",
        "RAJ KUMARI GAUTAM",
        "DIPLOMA IN PHARMACY",
        "",
        "2100",
        "1844",
        "87.80952380952381",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "9",
        "23141011",
        "23PS011",
        "GUNJAN",
        "गुंजन",
        "BHARAT SHARMA",
        "भरत शर्मा",
        "SAROJ BALA",
        "DIPLOMA IN PHARMACY",
        "",
        "2100",
        "1765",
        "84.04761904761905",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "10",
        "23141012",
        "23PS012",
        "KOMAL",
        "कोमल",
        "HAKIM SINGH",
        "हाकिम सिंह",
        "URVASHI",
        "DIPLOMA IN PHARMACY",
        "",
        "2100",
        "1811",
        "86.23809523809524",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "11",
        "23141013",
        "23PS013",
        "LALIT",
        "ललित",
        "SUBHASH CHAND",
        "सुभाष चंद",
        "SUDHA",
        "DIPLOMA IN PHARMACY",
        "",
        "2100",
        "1348",
        "64.19047619047619",
        "First Division",
        "MAY-2025"
      ],
      [
        "12",
        "23141014",
        "23PS014",
        "LOKESH",
        "लोकेश",
        "NARESH",
        "नरेश",
        "REKHA",
        "DIPLOMA IN PHARMACY",
        "",
        "2100",
        "1635",
        "77.85714285714286",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "13",
        "23141015",
        "23PS015",
        "MAMTA KUMARI",
        "ममता कुमारी",
        "DHARAM CHAND SHARMA",
        "धर्म चंद शर्मा",
        "KANTA SHARMA",
        "DIPLOMA IN PHARMACY",
        "",
        "2100",
        "1834",
        "87.33333333333333",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "14",
        "23141016",
        "23PS016",
        "MOHAN DUTT",
        "मोहन दत्त",
        "RAVI DUTT",
        "रवि दत्त",
        "GEETA DEVI",
        "DIPLOMA IN PHARMACY",
        "",
        "2100",
        "1313",
        "62.523809523809526",
        "First Division",
        "MAY-2025"
      ],
      [
        "15",
        "23141017",
        "23PS017",
        "MUSHRRAF ALI",
        "मुशर्रफ अली",
        "SAKIR HUSSAIN",
        "साकिर हुसैन",
        "HUSANNARA",
        "DIPLOMA IN PHARMACY",
        "",
        "2100",
        "1366",
        "65.04761904761905",
        "PASS Division",
        "SEPTEMBER-2025"
      ],
      [
        "16",
        "23141018",
        "23PS018",
        "PANKAJ",
        "पंकज",
        "SUBHASH CHAND",
        "सुभाष चंद",
        "KAMLA",
        "DIPLOMA IN PHARMACY",
        "",
        "2100",
        "1156",
        "55.04761904761905",
        "PASS Division",
        "SEPTEMBER-2025"
      ],
      [
        "17",
        "23141019",
        "23PS019",
        "RAHUL KUMAR",
        "राहुल कुमार",
        "MAHENDER SINGH",
        "महेंद्र सिंह",
        "SAROJ DEVI",
        "DIPLOMA IN PHARMACY",
        "",
        "2100",
        "1327",
        "63.19047619047619",
        "PASS Division",
        "SEPTEMBER-2025"
      ],
      [
        "18",
        "23141020",
        "23PS020",
        "RAVI KUMAR",
        "रवि कुमार",
        "AMI CHAND GOLA",
        "अमी चंद गोला",
        "MAMTA",
        "DIPLOMA IN PHARMACY",
        "",
        "2100",
        "1276",
        "60.76190476190476",
        "PASS Division",
        "SEPTEMBER-2025"
      ],
      [
        "19",
        "23141021",
        "23PS021",
        "REKHA",
        "रेखा",
        "RAJBIR",
        "राजबीर",
        "BABITA RANI",
        "DIPLOMA IN PHARMACY",
        "",
        "2100",
        "1805",
        "85.95238095238095",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "20",
        "23141024",
        "23PS024",
        "SHIVANI",
        "शिवानी",
        "ASHOK KAUSHIK",
        "अशोक कौशिक",
        "INDRA KAUSHIK",
        "DIPLOMA IN PHARMACY",
        "",
        "2100",
        "1598",
        "76.0952380952381",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "21",
        "23141025",
        "23PS025",
        "SONU ",
        "सोनू",
        "CHUNNILAL",
        "चुन्नीलाल",
        "KESHAR",
        "DIPLOMA IN PHARMACY",
        "",
        "2100",
        "1486",
        "70.76190476190476",
        "First Division",
        "MAY-2025"
      ],
      [
        "22",
        "23141026",
        "23PS026",
        "SOURAV",
        "सौरव",
        "RAJESH KUMAR",
        "राजेश कुमार",
        "LOVELY",
        "DIPLOMA IN PHARMACY",
        "",
        "2100",
        "1470",
        "70",
        "First Division",
        "MAY-2025"
      ],
      [
        "23",
        "23141027",
        "23PS027",
        "TIRATH RAM",
        "तीरथ राम",
        "ROOP CHAND",
        "रूप चंद",
        "JYOTI DEVI",
        "DIPLOMA IN PHARMACY",
        "",
        "2100",
        "1490",
        "70.95238095238095",
        "First Division",
        "MAY-2025"
      ],
      [
        "24",
        "23141030",
        "23PS030",
        "VIKRAM KUMAR CHAUDHARY",
        "विक्रम कुमार चौधरी",
        "VIJAY CHAUDHARY",
        "विजय चौधरी",
        "TETRI DEVI",
        "DIPLOMA IN PHARMACY",
        "",
        "2100",
        "1459",
        "69.47619047619048",
        "First Division",
        "MAY-2025"
      ],
      [
        "25",
        "23141031",
        "23PS031",
        "VINEET DAGAR",
        "विनीत डागर",
        "RAMESHWAR",
        "रामेश्वर",
        "SAVITA",
        "DIPLOMA IN PHARMACY",
        "",
        "2100",
        "1155",
        "55",
        "PASS Division",
        "SEPTEMBER-2025"
      ],
      [
        "26",
        "23141034",
        "23PS034",
        "YOGITA",
        "योगिता",
        "MAHESH",
        "महेश",
        "SEEMA",
        "DIPLOMA IN PHARMACY",
        "",
        "2100",
        "1869",
        "89",
        "First Division With Distinction",
        "MAY-2025"
      ],
      [
        "27",
        "23141036",
        "23PS036",
        "MANOJ KUMAR",
        "मनोज कुमार",
        "KAMAL SINGH",
        "कमल सिंह",
        "MAHENDRI",
        "DIPLOMA IN PHARMACY",
        "",
        "2100",
        "1374",
        "65.42857142857143",
        "PASS Division",
        "MAY-2025"
      ],
      [
        "28",
        "23141040",
        "23PS040",
        "MANISH",
        "मनीष",
        "SIKANDER",
        "सिकंदर",
        "SUNITA",
        "DIPLOMA IN PHARMACY",
        "",
        "2100",
        "1146",
        "54.57142857142857",
        "PASS Division",
        "MAY-2025"
      ],
      [
        "29",
        "23141041",
        "23PS041",
        "ROHIT",
        "रोहित",
        "PURAN SINGH",
        "पूरन सिंह",
        "SANTOSH",
        "DIPLOMA IN PHARMACY",
        "",
        "2100",
        "1262",
        "60.095238095238095",
        "First Division",
        "MAY-2025"
      ],
      [
        "30",
        "23141042",
        "23PS042",
        "MANISH KUMAR SOROUT",
        "मनीष कुमार सोरौत",
        "OM PRAKASH",
        "ओम प्रकाश",
        "RAJ WATI",
        "DIPLOMA IN PHARMACY",
        "",
        "2100",
        "1550",
        "73.80952380952381",
        "First Division",
        "MAY-2025"
      ],
      [
        "31",
        "23141043",
        "23PS043",
        "SUMIT KUMAR",
        "सुमित कुमार",
        "KUMAR PAL",
        "कुमार पाल",
        "RAJWATI",
        "DIPLOMA IN PHARMACY",
        "",
        "2100",
        "1216",
        "57.904761904761905",
        "PASS Division",
        "MAY-2025"
      ],
      [
        "32",
        "22141018",
        "22PS018",
        "FAISAL",
        "फैसल",
        "SAKIR",
        "साकिर",
        "REEHANA",
        "DIPLOMA IN PHARMACY",
        "",
        "1100",
        "763",
        "69.36363636363636",
        "PASS Division",
        "SEPTEMBER-2024"
      ],
      [
        "33",
        "22141019",
        "22PS019",
        "HARDEV",
        "हरदेव",
        "SURAJ",
        "सूरज",
        "GUDDI DEVI",
        "DIPLOMA IN PHARMACY",
        "",
        "1100",
        "650",
        "59.09090909090909",
        "PASS Division",
        "MAY-2025"
      ],
      [
        "34",
        "22141037",
        "22PS037",
        "PAWAN DAGAR",
        "पवन डागर",
        "RAMPRASHAD ",
        "रामप्रशाद",
        "BIMLESH",
        "DIPLOMA IN PHARMACY",
        "",
        "1100",
        "618",
        "56.18181818181818",
        "PASS Division",
        "SEPTEMBER-2025"
      ],
      [
        "35",
        "22141055",
        "22PS056",
        "VISHAL SOROUT",
        "विशाल सोरौत",
        "SHYAM SUNDER",
        "श्याम सुंदर",
        "REKHA",
        "DIPLOMA IN PHARMACY",
        "",
        "1100",
        "691",
        "62.81818181818182",
        "PASS Division",
        "SEPTEMBER-2024"
      ],
      [
        "36",
        "22141057",
        "22PS058",
        "NEERAJ KUMAR",
        "नीरज कुमार",
        "JHAMMAN LAL",
        "झम्मन लाल",
        "RAJ WATI",
        "DIPLOMA IN PHARMACY",
        "",
        "1100",
        "623",
        "56.63636363636363",
        "PASS Division",
        "MAY-2025"
      ],
      [
        "37",
        "21141025",
        "21PS025",
        "JAFRUDDIN",
        "जफरुद्दीन",
        "RAMJAN",
        "रामजन",
        "AMINA",
        "DIPLOMA IN PHARMACY",
        "",
        "1100",
        "621",
        "56.45454545454545",
        "PASS Division",
        "MAY-2025"
      ]
    ]
  },
  "Ph.D": {
    "headers": [
      "Sr. No.",
      "University Roll Number",
      "REGN. NO.",
      "Student Name",
      "छात्र का नाम",
      "Father name",
      "पिता का नाम",
      "MOTHER'S NAME",
      "Course\n Name ",
      "Stream",
      "Thesis Tittle",
      "Notification Date",
      ""
    ],
    "rows": [
      [
        "1",
        "19108002",
        "19SL9002",
        "DINESH MOHAN SINHA",
        "दिनेश मोहन सिन्हा",
        "MADAN MOHAN SINHA",
        "मदन मोहन सिन्हा",
        "PREM LATA SINHA",
        "Doctor of Philosophy",
        "(Law)",
        "Concept and Constitutional Validity of Prosecution Under Income Tax Act 1961: A Study in Light of Recent and Other Related Enactments ",
        "MAY 15, 2025",
        ""
      ],
      [
        "2",
        "20109003",
        "20BS/MT/9003/W",
        "KM. SANGITA SHEORAN",
        "\nकुमारी संगीता श्योराण",
        "MANGAL SINGH",
        "मंगल सिंह",
        "MAYA DEVI",
        "Doctor of Philosophy",
        "(Mathematics)",
        "On Some Studies In Bulk Transportation System Optimization",
        "AUGUST 05, 2025",
        ""
      ],
      [
        "3",
        "21108001",
        "21SL9001",
        "PRINCE KUMAR",
        "प्रिंस कुमार",
        "YUDHISTER",
        "युधिष्ठिर",
        "SANTOSH",
        "Doctor of Philosophy",
        "(Law)",
        "Environmental Impact Assessment Practices in The Context of Environmental Law: A Case Study of Indian Textile Industry",
        "SEPTEMBER 08, 2025",
        ""
      ],
      [
        "4",
        "19107004",
        "19PS9004/W",
        "KM. SWATI SRIVASTAVA",
        "\nकुमारी स्वाति श्रीवास्तव",
        "OM PRAKASH SRIVASTAVA",
        "ओम प्रकाश श्रीवास्तव",
        "JYOTI SRIVASTAVA",
        "Doctor of Philosophy",
        "PHARMACEUTICAL SCIENCES",
        "Quality Standards and Anti-Obesity Activity of Jatropha Tanjorensis & Fraxinus Micrantha",
        "OCTOBER 08, 2025",
        ""
      ],
      [
        "5",
        "20103002",
        "20CA9002",
        "ATUL RANA",
        "अतुल राणा",
        "BHAWAN SINGH RANA",
        "भवन सिंह राणा",
        "SUNITA RANA",
        "Doctor of Philosophy",
        "Computer Applications",
        "Organizational Infrastructure Security Through Attack Tree And Mitre Att&Ck Framwork",
        "OCTOBER 08, 2025",
        ""
      ],
      [
        "6",
        "17102002",
        "17BS/CH/9002",
        "LALITA",
        "ललिता",
        "HARSWARUP",
        "हरस्वरूप",
        "JAG WATI ",
        "Doctor of Philosophy",
        "CHEMISTRY",
        "Studies on Pyrolysis of Commodity Plastics with Biomass",
        "NOVEMBER 07, 2025",
        ""
      ],
      [
        "7",
        "21108004",
        "21SL9004/W",
        "SUSHIL KUMAR",
        "सुशील कुमार",
        "CHARAN SINGH",
        "चरण सिंह",
        "CHAMELI DEVI",
        "Doctor of Philosophy",
        "(Law)",
        "Honour Killing, A Grey Side of Life and Personal Liberty: A Comparative Study",
        "NOVEMBER 17, 2025",
        ""
      ],
      [
        "8",
        "20107001",
        "20PS9001/W",
        "MAHESH KUMAR",
        "महेश कुमार",
        "KAPTAIN SINGH",
        "कप्तान सिंह",
        "MUNESH DEVI",
        "Doctor of Philosophy",
        "PHARMACEUTICAL SCIENCES",
        "In-Vitro & In-VIVO Evaluation of Formulations of Anti-Tubercular Drugs",
        "NOVEMBER 07, 2025",
        ""
      ]
    ]
  }
}; 


const sheetNames = Object.keys(sheets);
const [activeTab, setActiveTab] = useState(sheetNames[0]);



      const notificationList=[

        {
            title:'',
            src: `${process.env.PUBLIC_URL}/assets/img/convocation/convocation01.jpg`, 
            link: ``
        }, 
         {
            title:'',
            src: `${process.env.PUBLIC_URL}/assets/img/convocation/convocation02.jpg`, 
            link: ``
        },
         {
            title:'',
            src: `${process.env.PUBLIC_URL}/assets/img/convocation/convocation03.jpg`, 
            link: ``
        },
         {
            title:'',
            src: `${process.env.PUBLIC_URL}/assets/img/convocation/convocation04.jpg`, 
            link: ``
        },
         {
            title:'',
            src: `${process.env.PUBLIC_URL}/assets/img/convocation/convocation05.jpg`, 
            link: ``
        },
         {
            title:'',
            src: `${process.env.PUBLIC_URL}/assets/img/convocation/convocation06.jpg`, 
            link: ``
        },
         {
            title:'',
            src: `${process.env.PUBLIC_URL}/assets/img/convocation/convocation08.jpg`, 
            link: ``
        },
         {
            title:'',
            src: `${process.env.PUBLIC_URL}/assets/img/convocation/convocation09.jpg`, 
            link: ``
        },
         {
            title:'',
            src: `${process.env.PUBLIC_URL}/assets/img/convocation/convocation10.jpg`, 
            link: ``
        },
    ]




  return (
    <>
      <NewMain />
      <section className="breadcrumb-area d-flex  p-relative align-items-center" style={{ backgroundImage: "url(/assets/img/10th_convocation_banner01.jpg)", backgroundSize: "100% 100%" }} >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-12 col-lg-12">
              <div className="breadcrumb-wrap text-left">
                <div className="breadcrumb-title">
                  {/* <h2> {image?"":subtitle} </h2> */}
                </div>
              </div>
            </div>
            <div className="breadcrumb-wrap2">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/"> Home </Link>
                  </li> 
                  <li className="breadcrumb-item">
                    <Link to="/convocation">10th Convocation </Link>
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </section>

      <section className="about-area about-p pt-60 pb-60 p-relative fix">
            <div className="container">
            <h2 class="text-center"> 10th Convocation: <i>MVN University – Inspiring Minds, Transforming Lives </i>
            </h2>
            <br/> 
            </div>
                
            <div className="container">
                <div className="row" >
                    <div className="col-sm-12 col-md-12 col-lg-12">
                        <div class="mvn_imse_omse">
                          <h3 class="sub_title"> Celebrating A Decade of Academic Excellence </h3> 
                           <p className="text-justify">
                            MVN University proudly announces its <strong>10th Convocation Ceremony </strong>, a milestone event that marks ten years of shaping futures, nurturing talent, and empowering young minds with knowledge and values. This convocation is a celebration of the hard work, determination, and achievements of our graduating students across various disciplines.
                        </p>
                        
                        </div> 


                       

                        <div class="mvn_imse_omse">
                          <h3 class="sub_title">A Moment of Honor and Achievement </h3>
                          <p> The Convocation Ceremony stands as one of the most significant occasions in a student's academic journey. It is a day when dreams of students meet recognition, receive earned degrees and step into a world of new opportunities. Families, faculty members, and distinguished guests join to witness this remarkable transition. </p>
                        </div> 

                        <div class="mvn_imse_omse">
                          <h3 class="sub_title"> Highlights of the Ceremony </h3>
                           <ul>
                              <li><strong>   Award of Degrees and Diplomas</strong>  to undergraduate, postgraduate, and doctoral graduates</li>
                              <li> <strong>Recognition of Academic Excellence </strong>  through medals and special honors </li>
                              <li><strong>Inspiring Address by the Chief Guest, </strong>  an eminent personality from academia/industry </li>
                              <li> <strong>Message from University </strong>  Leadership, celebrating ten years of progress </li>
                              <li> <strong>	Cultural Performances </strong>  showcasing the talent and spirit of MVN University </li>
                              <li> <strong>Memorable Photography Moments  </strong> to capture the proud day</li>
                           </ul>
                        </div> 

                         
                        <div class="mvn_imse_omse">
                           <h3 class="sub_title"> A Decade of Vision and Growth</h3>
                          <p> As MVN University celebrates its 10th Convocation, it also reflects on a decade of innovation in teaching, research, and campus development. With a commitment to quality education, industry-focused learning, and holistic growth, the university continues to build leaders who contribute to society with integrity and excellence.
  </p>


                          


                        </div> 

                        <div class="mvn_imse_omse">
                          <h3 class="sub_title">Join Us in the Celebration  </h3>
                          <p>  We invite graduates, parents, alumni, faculty, and well-wishers to be part of this proud moment. Let us come together to honor the achievements of our students and embrace the promise of a bright future ahead.  </p>
                          
                        </div> 
                         <div class="mvn_imse_omse">
                          <h3 class="sub_title">Details of the Convocation:</h3>
                           <ul>
                              <li>Date: 10th January 2026</li>
                              <li>Time: 11:00 AM Onwards</li>
                              <li>Note: Students are requested to come on time. No Entry after 11:00 AM.</li>
                           </ul>
                          
                        </div> 

                        <div class="mvn_imse_omse">
                          <h3 class="sub_title">Convocation Fees:</h3>
                          <p> To facilitate your participation, kindly note the following fees:</p>
                          <p> <strong>Registration Fee: </strong> Rs. 2000/- (for those attending the convocation in person) </p>
                          <p> <strong>Spot Registration Fee:  </strong> Rs. 2500/- </p>
                          <p> <strong>Degree Collection Fees:  </strong>
                              <li> Within six months: Rs. 3500/-</li>
                              <li> Six months to one year: Rs. 4500/-</li>
                              <li> After one year: Rs. 6000/- </li>
                          </p>
                          
                        </div> 

                        <div class="mvn_imse_omse">
                          <h3 class="sub_title"> Additional Information: </h3>
                          <p>  Max. two family members are allowed to accompany each student, with an additional fee of Rs. 500/- per person. </p>
                           
                        </div> 

                        <div class="mvn_imse_omse">
                          <h3 class="sub_title">Registration Link: </h3>
                          <p>  <a  href="https://forms.gle/TeFK1na6JEwm3d3L8" style={{ color: 'red'  }} > https://forms.gle/TeFK1na6JEwm3d3L8 </a>  </p>
                           
                        </div> 

                        <div class="mvn_imse_omse">
                          <h3 class="sub_title">Apply FORM FOR DIPLOMA/DEGREE CERTIFICATE : </h3>
                          <p> <a href="/assets/img/20_application_for_orignal_diploma_degree_certificate.pdf" style={{ color: 'red'  }} > Download Form </a>  </p>
                           
                        </div> 

                        <div class="mvn_imse_omse">
                          <h3 class="sub_title">Apply For Degree Correction : </h3>
                          <p> <a href="https://forms.gle/Ud1nuxDvwAzPrRbq7" target="_blank" style={{ color: 'red'  }} > Apply Now </a>  </p>
                           
                        </div> 




 



                        <div class="mvn_imse_omse"> 
                          <p>  Please ensure that you complete the registration process by 2nd January 2026 to confirm your participation. </p>
                        </div> 

 

       
        <div className="container-fluid mt-4">
<h2 className="mb-4 text-center">10th Convocation January 2026</h2>


<ul className="nav nav-tabs">
{sheetNames.map((name) => (
<li className="nav-item" key={name}>
<button
className={`nav-link ${activeTab === name ? "active" : ""}`}
onClick={() => setActiveTab(name)}
>
{name}
</button>
</li>
))}
</ul>


<div className="tab-content mt-3">
{sheetNames.map((name) => (
<div
key={name}
className={`tab-pane fade ${activeTab === name ? "show active" : ""}`}
>
<div className="table-responsive">
<table className="table table-bordered table-striped">
<thead className="table-dark">
<tr>
{sheets[name].headers.map((h, i) => (
<th key={i}>{h}</th>
))}
</tr>
</thead>
<tbody>
{sheets[name].rows.map((row, rIdx) => (
<tr key={rIdx}>
{row.map((cell, cIdx) => (
<td key={cIdx}>{cell}</td>
))}
</tr>
))}
</tbody>
</table>
</div>
</div>
))}
</div>
</div>
       
<br/><br/>

                        <Grid container spacing={3}>
                        <Grid item xs={12} sm={12} md={12} lg={12}>
                            <MainTitle title="Glimpse of Previous Convocation" />
                        </Grid>
                        <Grid item xs={12} sm={12} md={12} lg={12} >
                            <Container>
                            <div className='gallerylist_home'>
                                <HomegalleryCompo notificationList={notificationList} />  
                            </div>
                            </Container>
                        </Grid>
                    </Grid>
                    
 

                        
                </div>
            </div>
            </div>

 

        </section>
    </>
  )
}

export default Convocation10th